import "./Dashboard.css";
import React, { Suspense, useState, useEffect } from "react";
import "react-toggle/style.css";
import { Link, useHistory } from "react-router-dom";
import swal from "sweetalert";
import { Button } from "reactstrap";
import { DashboardTableLoader } from "../../components/DashboardLoader.js";
import Loading from "../../components/Loading";
import { getTenantList } from "../../actions/propertyAction";
import LoggedHeader from "../../DefaultLayout/LoggedHeader";
import Footer from "../../DefaultLayout/Footer";
import DashboardNavbar from "../../DefaultLayout/DashboardNavbar.js";
import { connect, useSelector } from "react-redux";
import Header from "../../DefaultLayout/Header";
import { runningSubscription } from "../../actions/subscription";
import { changePassword, loadUser } from "../../actions/authActions";
import { getAllChat } from "../../actions/firebaseAction";
import { toast } from "react-toastify";
import moment from "moment";
import { getfavriteList } from "../../actions/favriteAction";
import {
  getPropertyList,
  likeProperty,
  hiddenProperty,
  unlikeProperty,
} from "../../actions/propertyAction";
import { unHideProperties } from "../../actions/hiddenPropertyAction";
import { getPropertyWatch } from "../../actions/propertyAction";
import {
  dashboardSubscription,
  ChangeTenantStatus,
} from "../../actions/subscription";
import { gethiddenList } from "../../actions/hiddenAction";
import { getapplyPropertyList } from "../../actions/applyAction";
import { watchList, watchListDetail } from "../../actions/watchList";
import { dropdownPropertyField } from "../../actions/propertyFieldAction";
import $ from "jquery";
import { Box, Pagination } from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import PaymentModal from "../../View/Subscription/PaymentModal";
import { getAllSubscription } from "../../actions/subscription.js";
import Switch from "./Switch";
import Skeleton from "@mui/material/Skeleton";
import { frontLabel } from "../../Helpers/labels.js";

const Inbox = React.lazy(() => import("./Inbox")); // Lazy-loaded

const theme = createTheme({
  palette: {
    primary: {
      main: "#f5d792",
      darker: "#053e85",
    },
    neutral: {
      main: "#64748B",
      contrastText: "#fff",
    },
  },
});

function Dashboard(props) {
  const lng = localStorage.getItem("prevLangFront");
  const history = useHistory();
  const {
    getfavriteList,
    gethiddenList,
    getapplyPropertyList,
    getTenantList,
    getPropertyList,
    auth,
  } = props;
  const { frontLabelsName } = props.label;

  const [show, setShow] = useState(true);

  const [isMobile, setIsMobile] = useState(window.innerWidth < 1200);
  const [checked, setChecked] = useState(true);
  const [detailData, setDetailData] = useState();

  const [expand, setExpand] = useState(false);
  const [expandId, setExpandId] = useState(null);
  const [dashboardSubDetails, setDashboardSubDetails] = useState("");
  const [propertyWatchData, setPropertyWatchData] = useState({});
  const handleExpand = (state, id) => {
    setExpand(state);
    setExpandId(id);
  };

  const favrites = useSelector((state) => state.favorites);
  const hiden = useSelector((state) => state.hiddens);
  const applyedproperty = useSelector((state) => state.applyproperty);
  const subscriptions = useSelector((state) => state.subscription);
  const runningsubscriptions = useSelector(
    (state) => state.subscription.runningSubscription,
  );
  console.log("runningsubscriptions: ", runningsubscriptions);
  const properties = useSelector((state) => state.properties);
  const { property, tenantList } = properties;
  const [sms, setSms] = useState(false);
  const [email, setEmail] = useState(false);
  const [web, setWeb] = useState(false);
  const [propertyWatch, setPropertyWatch] = useState(false);
  const [propertyWatchToggle, setPropertyWatchToggle] = useState(false);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);

  const [activeTab, setactiveTab] = useState(true);
  const [tabId, setTabId] = useState(1);
  const [watchTabId, setWatchTabId] = useState(1);
  const [criteria, setCriteria] = useState([]);
  const [criteriaPage, setCriteriaPage] = useState("");
  const [criteriaDocs, setCriteriaDocs] = useState([]);
  const [showPaymentModal, setShowPaymentModal] = useState(false);

  const [homeApplianceType, setHomeApplianceType] = useState([]);
  const [restrictionsType, setRestrictionsType] = useState([]);
  const [accessType, setAccessType] = useState([]);
  const [otherTypeField, setOtherTypeField] = useState([]);

  const [isLoading, setIsLoading] = useState(true);
  const [authLoading, setAuthLoading] = useState(true);
  const [loading, setLoading] = useState(true);
  const [propertyWatchLoading, setPropertyWatchLoading] = useState(true);
  const isAuth = props.auth.isAuthenticated;
  const userName = props.auth.user;

  const [runningSub, setRunningSub] = useState("");
  const { favorite } = favrites;
  const { hidden } = hiden;
  const { appProperty } = applyedproperty;

  const { allSubscription } = subscriptions;
  // console.log('allSubscription: ', subscriptions);

  useEffect(() => {
    if (auth?.user?.dayssince == 0) {
      props.getAllSubscription();
    }
  }, [auth?.user?.dayssince]);

  useEffect(() => {
    setLoading(true);
    getTenantList();
    getfavriteList();
    getPropertyList(1, 100).then((res) => {
      setLoading(false);
    });

    // likeProperty();
  }, []);

  useEffect(() => {
    gethiddenList();
    hiddenProperty();
  }, []);

  useEffect(() => {
    getapplyPropertyList();
  }, []);

  useEffect(() => {
    setAuthLoading(true);
    setEmail(userName?.property_watch_email);
    setSms(userName?.property_watch_sms);
    setPropertyWatch(userName?.property_watch);
    setPropertyWatchToggle(userName?.property_watch);
    setWeb(userName?.property_watch_web);
    setAuthLoading(false);
  }, [userName]);

  const handlePageChange = (e, p) => {
    setPage(p);

    props.watchListDetail(p, limit).then((res) => {
      setCriteria(res.data.result.docs);
    });
  };

  useEffect(() => {
    // const userId = localStorage.getItem("user");
    // props.runningSubscription(userId).then((res) => {
    //   console.log('res: ', res);
    //   setRunningSub(res);

    if (runningsubscriptions.message == "Your subscription is active.") {
      $(".backdrop").fadeOut(200);
      $(".backdrop-second").fadeOut(200);
      setShow(false);
    } else if (
      runningsubscriptions.message == "Your subscription is expired."
    ) {
      $(".backdrop").fadeTo(200, 1);
      $(".backdrop-second").fadeTo(200, 1);
      setShow(true);
    }
    // });
  }, []);

  useEffect(() => {
    setPropertyWatchLoading(true);
    props.getPropertyWatch().then((res) => {
      setPropertyWatchData(res);
      setPropertyWatchLoading(false);
    });
  }, []);

  useEffect(() => {
    setIsLoading(true);
    props.dashboardSubscription().then((res) => {
      setDashboardSubDetails(res);

      res.rental_listing_enabled == 1 && setChecked(false);
      res.rental_listing_enabled == 2 && setChecked(true);
      setIsLoading(false);
    });
  }, []);
  useEffect(() => {
    window.addEventListener(
      "resize",
      () => {
        const ismobile = window.innerWidth < 990;
        if (ismobile !== isMobile) setIsMobile(ismobile);
      },
      false,
    );
  }, [isMobile]);

  useEffect(() => {
    props.dropdownPropertyField("").then((res) => {
      setHomeApplianceType(res?.type_2);
      setRestrictionsType(res?.type_3);
      setAccessType(res?.type4);
      setOtherTypeField(res?.type5);
    });
  }, []);

  const handleChange = (e) => {
    let newValue = "";
    setChecked(!checked);

    if (checked === true) {
      newValue = 1;
    } else {
      newValue = 2;
    }

    props.ChangeTenantStatus(newValue).then((res) => {
      // toast.success(res.data.message);
      props.dashboardSubscription();
    });
  };

  const selectTab = (id) => {
    setTabId(id);
  };

  const selectwatchListTab = (id) => {
    setWatchTabId(id);
  };

  // change password function

  // const handlePassword = () => {
  //   if (oldPassword === "") {
  //     toast.error("Please enter old password");
  //   } else if (newPassword === "") {
  //     toast.error("Please enter New password");
  //   } else if (confirmPassword === "") {
  //     toast.error("Please enter confirm password");
  //   } else if (newPassword !== confirmPassword) {
  //     toast.error("Confirm password didn't match");
  //   } else {
  //     const data = {
  //       old_password: oldPassword,
  //       new_password: newPassword,
  //       confirm_password: confirmPassword,
  //     };
  //     props.changePassword(data).then((res) => {
  //       if (res) {
  //         props.loadUser();

  //         setOldPassword("");
  //         setNewPassword("");
  //         setConfirmPassword("");
  //       }
  //     });
  //   }
  // };

  // const getDateInfo = (dates) => {
  //   const fbData = new Date(dates?.seconds * 1000)
  //   const ts = new Date()

  //   const diffTime = Math.abs(ts - fbData)
  //   const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))

  //   if (diffDays === 1) {
  //     const ifData = moment(
  //       dates?.seconds * 1000 + dates?.nanoseconds / 1000000
  //     )
  //       .startOf('minute')
  //       .fromNow()

  //     if (ifData != 'Invalid date') {
  //       return ifData
  //     } else {
  //       return ''
  //     }
  //   } else {
  //     const elseData = moment(
  //       dates?.seconds * 1000 + dates?.nanoseconds / 1000000
  //     ).format(dateFormat)

  //     if (elseData != 'Invalid date') {
  //       return elseData
  //     } else {
  //       return ''
  //     }
  //   }
  // }

  // unlike funtion start here

  const unlike = async (data) => {
    const id = data?.propertyData?._id;
    if (auth.isAuthenticated) {
      props.unlikeProperty(id).then((Response) => {
        toast.success(
          frontLabelsName
            ? frontLabelsName.filter((e) => e.key == Response.message).length >
              0
              ? frontLabelsName.filter((e) => e.key == Response.message)[0][
                  "value"
                ] || Response.message
              : Response.message
            : Response.message,
        );
        props.getfavriteList(id).then((res) => {
          setDetailData(res);
        });
      });
    } else {
      toast.error(
        frontLabelsName
          ? frontLabelsName.filter((e) => e.key == "lbl_please_login_to_access")
              .length > 0
            ? frontLabelsName.filter(
                (e) => e.key == "lbl_please_login_to_access",
              )[0]["value"] || "lbl_please_login_to_access"
            : "lbl_please_login_to_access"
          : "lbl_please_login_to_access",
      );
    }
  };

  // hidden property start here

  const hide = async (obj) => {
    const id = obj?.propertyData?._id;
    if (auth.isAuthenticated) {
      const res = await props.unHideProperties(id).then((Response) => {
        toast.success(
          frontLabelsName
            ? frontLabelsName.filter((e) => e.key == Response.data.message)
                .length > 0
              ? frontLabelsName.filter(
                  (e) => e.key == Response.data.message,
                )[0]["value"] || Response.data.message
              : Response.data.message
            : Response.data.message,
        );
        gethiddenList(id).then((res) => {
          setDetailData(res);
        });
        // history.push("/properties");
      });
    } else {
      toast.error(
        frontLabelsName
          ? frontLabelsName.filter((e) => e.key == "lbl_please_login_to_access")
              .length > 0
            ? frontLabelsName.filter(
                (e) => e.key == "lbl_please_login_to_access",
              )[0]["value"] || "lbl_please_login_to_access"
            : "lbl_please_login_to_access"
          : "lbl_please_login_to_access",
      );
    }
  };

  const trimString = (str, limit) => {
    return str?.length > limit ? str?.substring(0, limit) + "...." : str + " ";
  };

  const getDepositTypeName = (arr) => {
    let depositArray = [];
    for (let i = 0; i < arr.length; i++) {
      if (arr[i] === "renters_insurance") {
        depositArray.push(
          frontLabelsName
            ? frontLabelsName.filter((e) => e.key == "lbl_renters_insurance")
                .length > 0
              ? frontLabelsName.filter(
                  (e) => e.key == "lbl_renters_insurance",
                )[0]["value"] || "lbl_renters_insurance"
              : "lbl_renters_insurance"
            : "lbl_renters_insurance",
        );
      } else if (arr[i] === "security_deposit") {
        depositArray.push(
          frontLabelsName
            ? frontLabelsName.filter((e) => e.key == "lbl_security_deposit")
                .length > 0
              ? frontLabelsName.filter(
                  (e) => e.key == "lbl_security_deposit",
                )[0]["value"] || "lbl_security_deposit"
              : "lbl_security_deposit"
            : "lbl_security_deposit",
        );
      } else if (arr[i] === "bank_guarantee") {
        depositArray.push(
          frontLabelsName
            ? frontLabelsName.filter((e) => e.key == "lbl_bank_guarantee")
                .length > 0
              ? frontLabelsName.filter((e) => e.key == "lbl_bank_guarantee")[0][
                  "value"
                ] || "lbl_bank_guarantee"
              : "lbl_bank_guarantee"
            : "lbl_bank_guarantee",
        );
      } else if (arr[i] === "collateral") {
        depositArray.push(
          frontLabelsName
            ? frontLabelsName.filter((e) => e.key == "lbl_collateral").length >
              0
              ? frontLabelsName.filter((e) => e.key == "lbl_collateral")[0][
                  "value"
                ] || "lbl_collateral"
              : "lbl_collateral"
            : "lbl_collateral",
        );
      } else if (arr[i] === "other") {
        depositArray.push(
          frontLabelsName
            ? frontLabelsName.filter((e) => e.key == "lbl_other").length > 0
              ? frontLabelsName.filter((e) => e.key == "lbl_other")[0][
                  "value"
                ] || "lbl_other"
              : "lbl_other"
            : "lbl_other",
        );
      }
    }
    return depositArray.toString();
  };

  const getTypeName = (arr) => {
    var a = [];
    for (let i = 0; i < arr.length; i++) {
      if (arr[i] === "detachedHouse") {
        a.push(
          frontLabelsName
            ? frontLabelsName.filter((e) => e.key == "lbl_detached_house")
                .length > 0
              ? frontLabelsName.filter((e) => e.key == "lbl_detached_house")[0][
                  "value"
                ] || "lbl_detached_house"
              : "lbl_detached_house"
            : "lbl_detached_house",
        );
      } else if (arr[i] === "duplex") {
        a.push(
          frontLabelsName
            ? frontLabelsName.filter((e) => e.key == "lbl_duplex").length > 0
              ? frontLabelsName.filter((e) => e.key == "lbl_duplex")[0][
                  "value"
                ] || "lbl_duplex"
              : "lbl_duplex"
            : "lbl_duplex",
        );
      } else if (arr[i] === "tripleAptHouse") {
        a.push(
          frontLabelsName
            ? frontLabelsName.filter((e) => e.key == "lbl_triple_apt_house")
                .length > 0
              ? frontLabelsName.filter(
                  (e) => e.key == "lbl_triple_apt_house",
                )[0]["value"] || "lbl_triple_apt_house"
              : "lbl_triple_apt_house"
            : "lbl_triple_apt_house",
        );
      } else if (arr[i] === "aptBulding") {
        a.push(
          frontLabelsName
            ? frontLabelsName.filter((e) => e.key == "lbl_apt_building")
                .length > 0
              ? frontLabelsName.filter((e) => e.key == "lbl_apt_building")[0][
                  "value"
                ] || "lbl_apt_building"
              : "lbl_apt_building"
            : "lbl_apt_building",
        );
      } else if (arr[i] === "townhouseTwin") {
        a.push(
          frontLabelsName
            ? frontLabelsName.filter((e) => e.key == "lbl_townhouse_twin")
                .length > 0
              ? frontLabelsName.filter((e) => e.key == "lbl_townhouse_twin")[0][
                  "value"
                ] || "lbl_townhouse_twin"
              : "lbl_townhouse_twin"
            : "lbl_townhouse_twin",
        );
      } else if (arr[i] === "garage") {
        a.push(
          frontLabelsName
            ? frontLabelsName.filter((e) => e.key == "lbl_garage").length > 0
              ? frontLabelsName.filter((e) => e.key == "lbl_garage")[0][
                  "value"
                ] || "lbl_garage"
              : "lbl_garage"
            : "lbl_garage",
        );
      } else if (arr[i] === "summerHouse") {
        a.push(
          frontLabelsName
            ? frontLabelsName.filter((e) => e.key == "lbl_summer_house")
                .length > 0
              ? frontLabelsName.filter((e) => e.key == "lbl_summer_house")[0][
                  "value"
                ] || "lbl_summer_house"
              : "lbl_summer_house"
            : "lbl_summer_house",
        );
      } else if (arr[i] === "cotenant") {
        a.push(
          frontLabelsName
            ? frontLabelsName.filter((e) => e.key == "lbl_co_tenant").length > 0
              ? frontLabelsName.filter((e) => e.key == "lbl_co_tenant")[0][
                  "value"
                ] || "lbl_co_tenant"
              : "lbl_co_tenant"
            : "lbl_co_tenant",
        );
      } else if (arr[i] === "hotelGesthouse") {
        a.push(
          frontLabelsName
            ? frontLabelsName.filter((e) => e.key == "lbl_hotel_guest_house")
                .length > 0
              ? frontLabelsName.filter(
                  (e) => e.key == "lbl_hotel_guest_house",
                )[0]["value"] || "lbl_hotel_guest_house"
              : "lbl_hotel_guest_house"
            : "lbl_hotel_guest_house",
        );
      }
    }

    return a.toString();
  };

  function priceFormat(x) {
    const data = x?.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ".");
    return data;
  }

  const handlePropertyWatchChange = () => {
    setPropertyWatchToggle(!propertyWatchToggle);

    let newdata = {
      property_watch_email: email,
      property_watch_sms: sms,
      property_watch: JSON.stringify(!propertyWatchToggle),
      property_watch_web: web,
    };

    props.watchList(newdata).then((Response) => {
      // props.loadUser();
      toast.success(
        frontLabelsName
          ? frontLabelsName.filter((e) => e.key == Response.data.message)
              .length > 0
            ? frontLabelsName.filter((e) => e.key == Response.data.message)[0][
                "value"
              ] || Response.data.message
            : Response.data.message
          : Response.data.message,
      );
    });
  };

  const HandleWatchList = (e, type) => {
    // e.preventDefault();

    let newdata = {};
    if (type === 1) {
      newdata = {
        property_watch_email: e.target.checked.toString(""),
        property_watch_sms: sms.toString(""),
        property_watch: propertyWatch.toString(""),
        property_watch_web: web.toString(""),
      };
      setPropertyWatchData((prev) => ({
        ...prev,
        user: {
          ...prev.user,
          property_watch_email: e.target.checked, // update only email
        },
      }));
      setEmail(e.target.checked);
    }
    if (type == 2) {
      newdata = {
        property_watch_email: email.toString(""),
        property_watch_sms: e.target.checked.toString(""),
        property_watch: propertyWatch.toString(""),
        property_watch_web: web.toString(""),
      };
      setPropertyWatchData((prev) => ({
        ...prev,
        user: {
          ...prev.user,
          property_watch_sms: e.target.checked, // update only email
        },
      }));

      setSms(e.target.checked);
    }
    if (type == 3) {
      newdata = {
        property_watch_email: email.toString(""),
        property_watch_sms: sms.toString(""),
        property_watch: propertyWatch.toString(""),
        property_watch_web: e.target.checked.toString(""),
      };
      setPropertyWatchData((prev) => ({
        ...prev,
        user: {
          ...prev.user,
          property_watch_web: e.target.checked, // update only email
        },
      }));
      setWeb(e.target.checked);
    }
    if (type == 4) {
      newdata = {
        property_watch_email: email.toString(""),
        property_watch_sms: sms.toString(""),
        property_watch: e.target.checked.toString(""),
        property_watch_web: web.toString(""),
      };
      setPropertyWatchData((prev) => ({
        ...prev,
        user: {
          ...prev.user,
          property_watch: e.target.checked, // update only email
        },
      }));
      setPropertyWatch(e.target.checked);
    }

    if (type == 5) {
      setPropertyWatch(false);
      newdata = {
        property_watch_email: email.toString(""),
        property_watch_sms: sms.toString(""),
        property_watch: "false",
        property_watch_web: web.toString(""),
      };
    }

    props.watchList(newdata).then((Response) => {
      toast.success(
        frontLabelsName
          ? frontLabelsName.filter((e) => e.key == Response.data.message)
              .length > 0
            ? frontLabelsName.filter((e) => e.key == Response.data.message)[0][
                "value"
              ] || Response.data.message
            : Response.data.message
          : Response.data.message,
      );
    });
  };

  const HandleClick = () => {
    props.watchListDetail(page, limit).then((res) => {
      setCriteriaPage(res.data.result.totalPages);
      setCriteriaDocs(res.data.result.docs);

      let data = res.data.result.docs.map((res) => {
        return res;
      });
      setCriteria(data);
    });
  };

  const includs = (filedData, newData) => {
    let result = filedData.filter(function (obj) {
      return newData.some(function (val) {
        return val === obj._id;
      });
    });

    let dd = result.map((d) =>
      Array.isArray(d?.name)
        ? d?.name?.filter((e) => e[lng])[0][lng]["name"]
        : d?.name,
    );
    var output = dd.join(", ");

    return output;
  };

  const savePaymentModal = () => {
    setShowPaymentModal(false);
  };

  const handleSubscribe = (datas) => {
    if (!isLoading && dashboardSubDetails?.remaining_days !== 0) {
      swal({
        title: frontLabelsName
          ? frontLabelsName.filter(
              (e) => e.key == "lbl_get_access_to_leigulistinn!",
            ).length > 0
            ? frontLabelsName.filter(
                (e) => e.key == "lbl_get_access_to_leigulistinn!",
              )[0]["value"] || "lbl_get_access_to_leigulistinn!"
            : "lbl_get_access_to_leigulistinn!"
          : "lbl_get_access_to_leigulistinn!",
        text: `${
          frontLabelsName
            ? frontLabelsName.filter(
                (e) => e.key == "lbl_subscription_amount_is",
              ).length > 0
              ? frontLabelsName.filter(
                  (e) => e.key == "lbl_subscription_amount_is",
                )[0]["value"] || "lbl_subscription_amount_is"
              : "lbl_subscription_amount_is"
            : "lbl_subscription_amount_is"
        } ISK${allSubscription?.amount}`,
        icon: "info",
        buttons: [
          frontLabelsName
            ? frontLabelsName.filter((e) => e.key == "lbl_cancel").length > 0
              ? frontLabelsName.filter((e) => e.key == "lbl_cancel")[0][
                  "value"
                ] || "lbl_cancel"
              : "lbl_cancel"
            : "lbl_cancel",
          frontLabelsName
            ? frontLabelsName.filter((e) => e.key == "lbl_continue").length > 0
              ? frontLabelsName.filter((e) => e.key == "lbl_continue")[0][
                  "value"
                ] || "lbl_continue"
              : "lbl_continue"
            : "lbl_continue",
        ],
        dangerMode: true,
        className: "bg-button",
      }).then((willDelete) => {
        if (willDelete) {
          setShowPaymentModal(true);
        }
      });
    }
  };

  return (
    <React.Fragment>
      <Suspense fallback={<Loading />}>
        {isAuth ? <LoggedHeader /> : <Header />}
        <DashboardNavbar />
      </Suspense>

      <div className="container-fluid dash-main-box">
        <div className="tilte-main-fonts">
          <h2 className="mb-3">
            {frontLabel(frontLabelsName, "lbl_welcome_rental_list")}-{" "}
            {userName?.full_name}
          </h2>
        </div>

        <div className="main-dash-di  p-3">
          <div
            className="row"
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <div
              className={`col-lg-7 col-md-12 d-grid ${
                isMobile ? " number-div" : "border-style-right"
              }`}
            >
              <div className="row d-flex align-items-center">
                <div
                  className="col-lg-3 col-md-6   number-div  d-flex align-content-center   justify-content-center"
                  style={{
                    flexDirection: "column",
                    flexWrap: "wrap",
                  }}
                >
                  <div class="paper">
                    <Link
                      to={"/subscription-info"}
                      style={{ textDecoration: "none" }}
                    >
                      <div
                        className={`fr-main-ds ${
                          isMobile ? "border-style-bottom" : ""
                        }`}
                      >
                        {isLoading && <Skeleton width={100} />}
                        {!isLoading &&
                        dashboardSubDetails?.remaining_days > 0 ? (
                          <h2>{dashboardSubDetails?.remaining_days}</h2>
                        ) : (
                          !isLoading && <h2>0</h2>
                        )}

                        <h5>
                          {frontLabel(frontLabelsName, "lbl_days_subscription")}
                        </h5>
                      </div>
                    </Link>
                  </div>
                  <div className="front_renew mt-3">
                    {dashboardSubDetails?.remaining_days != 0 ? (
                      <Button
                        onClick={() => handleSubscribe(allSubscription?._id)}
                        style={{ fontSize: "15px !important" }}
                      >
                        {frontLabel(frontLabelsName, "lbl_renew_subs")}
                      </Button>
                    ) : (
                      <div className="false-height-div"></div>
                    )}
                  </div>
                </div>
                <div className="col-lg-3 col-md-6">
                  <div
                    className={`fr-main-ds ${
                      isMobile ? "border-style-bottom" : ""
                    }`}
                  >
                    <div className="subscription-box ">
                      <Link
                        to={"/renters-info"}
                        style={{ textDecoration: "none" }}
                      >
                        <div
                          className={
                            lng == "en"
                              ? "subscription-body mb-2"
                              : `${"subscription-body-icelandic"} mb-2`
                          }
                        >
                          <h2
                            className="subscription  "
                            style={{ marginTop: lng == "en" ? "24px" : "14px" }}
                          >
                            {frontLabel(
                              frontLabelsName,
                              "lbl_to_tenant_list_for_free",
                            )}
                          </h2>
                        </div>
                      </Link>
                    </div>
                    <div className="front_renew mt-3 w-100">
                      <Button
                        className="lh-1 sign-up-button-tenant"
                        onClick={() => history.push("/renters-info")}
                        style={{ fontSize: "14px" }}
                      >
                        {frontLabel(frontLabelsName, "lbl_register_for_ls")}
                      </Button>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-md-12">
                  <div
                    className={`info-sube-des ${
                      isMobile ? "border-style-bottom mt-1 mb-2" : ""
                    }`}
                  >
                    <div className="desc-scibe d-flex">
                      <h2>
                        {frontLabel(frontLabelsName, "lbl_subs_valid_since")}
                      </h2>
                      {isLoading && <Skeleton width={100} />}
                      {!isLoading && dashboardSubDetails?.remaining_days > 0 ? (
                        dashboardSubDetails?.subscription_start_date ? (
                          <p>
                            {moment(
                              dashboardSubDetails?.subscription_start_date,
                            ).format("DD/MM/yyyy")}
                          </p>
                        ) : (
                          !isLoading && <p>---</p>
                        )
                      ) : (
                        !isLoading && <p>---</p>
                      )}
                    </div>
                    <div className="desc-scibe d-flex">
                      <h2>
                        {frontLabel(frontLabelsName, "lbl_last_time_logged_in")}
                      </h2>
                      {isLoading && <Skeleton width={100} />}

                      {!isLoading && dashboardSubDetails?.last_login ? (
                        <p>
                          {moment(dashboardSubDetails?.last_login).format(
                            "DD/MM/yyyy",
                          )}
                        </p>
                      ) : (
                        !isLoading && <p> --- </p>
                      )}
                    </div>
                    <div className="desc-scibe d-flex">
                      <h2 className="min-width-class2">
                        {frontLabelsName
                          ? frontLabelsName.filter(
                              (e) =>
                                e.key == "lbl_number_of_logged_in_sessions",
                            ).length > 0
                            ? frontLabelsName.filter(
                                (e) =>
                                  e.key == "lbl_number_of_logged_in_sessions",
                              )[0]["value"] ||
                              "lbl_number_of_logged_in_sessions"
                            : "lbl_number_of_logged_in_sessions"
                          : "lbl_number_of_logged_in_sessions"}
                      </h2>
                      {isLoading && <Skeleton width={100} />}
                      {!isLoading && dashboardSubDetails?.login_count ? (
                        <p>{dashboardSubDetails?.login_count}</p>
                      ) : (
                        !isLoading && <p> --- </p>
                      )}
                    </div>
                    <div className="desc-scibe d-flex">
                      <h2>
                        {frontLabelsName
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_payment",
                            ).length > 0
                            ? frontLabelsName.filter(
                                (e) => e.key == "lbl_payment",
                              )[0]["value"] || "lbl_payment"
                            : "lbl_payment"
                          : "lbl_payment"}
                      </h2>
                      {isLoading && <Skeleton width={100} />}

                      {!isLoading &&
                        runningsubscriptions?.message ==
                          "Your subscription is active." &&
                        runningsubscriptions?.result?.trans?.payment_data
                          ?.payment_method_type && (
                          <p>
                            {frontLabelsName
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_card",
                                ).length > 0
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_card",
                                  )[0]["value"] || "lbl_card"
                                : "lbl_card"
                              : "lbl_card"}
                          </p>
                        )}
                      {!isLoading &&
                        runningsubscriptions?.message ==
                          "Your subscription is active." &&
                        !runningsubscriptions?.result?.trans?.payment_data
                          ?.payment_method_type && (
                          <p>
                            {frontLabelsName
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_direct_bank_transfer",
                                ).length > 0
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_direct_bank_transfer",
                                  )[0]["value"] || "lbl_direct_bank_transfer"
                                : "lbl_direct_bank_transfer"
                              : "lbl_direct_bank_transfer"}
                          </p>
                        )}
                      {!isLoading &&
                        runningsubscriptions?.message !==
                          "Your subscription is active." && <p>---</p>}
                    </div>

                    <div className="desc-scibe d-flex">
                      <h2>
                        {" "}
                        {frontLabelsName
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_register_type",
                            ).length > 0
                            ? frontLabelsName.filter(
                                (e) => e.key == "lbl_register_type",
                              )[0]["value"] || "lbl_register_type"
                            : "lbl_register_type"
                          : "lbl_register_type"}
                      </h2>
                      <p>{dashboardSubDetails?.ipAddress}</p>
                      {/* <p>
                        {!isLoading &&
                          dashboardSubDetails?.register_type == 1 && (
                            <p>
                              {frontLabelsName
                                ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_electronic"
                                ).length > 0
                                  ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_electronic"
                                  )[0]["value"] || "lbl_electronic"
                                  : "lbl_electronic"
                                : "lbl_electronic"}
                            </p>
                          )}

                        {!isLoading &&
                          dashboardSubDetails?.register_type == 2 && (
                            <p>
                              {frontLabelsName
                                ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_sms/message"
                                ).length > 0
                                  ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_sms/message"
                                  )[0]["value"] || "lbl_sms/message"
                                  : "lbl_sms/message"
                                : "lbl_sms/message"}
                            </p>
                          )}
                        {isLoading && <Skeleton width={100} />}
                        {!isLoading &&
                          dashboardSubDetails?.register_type == 0 && (
                            <p>
                              {frontLabelsName
                                ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_admin_created"
                                ).length > 0
                                  ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_admin_created"
                                  )[0]["value"] || "lbl_admin_created"
                                  : "lbl_admin_created"
                                : "lbl_admin_created"}
                            </p>
                          )}
                      </p> */}
                    </div>
                    <div className="desc-scibe d-flex">
                      <Link
                        to={"/subscription-history"}
                        style={{ textDecoration: "underline", color: "#000" }}
                      >
                        <h2 className="subscription">
                          {frontLabelsName
                            ? frontLabelsName.filter(
                                (e) => e.key == "lbl_subscription_history",
                              ).length > 0
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_subscription_history",
                                )[0]["value"] || "lbl_subscription_history"
                              : "lbl_subscription_history"
                            : "lbl_subscription_history"}
                        </h2>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className={`col-lg-5 col-md-12`}>
              <div className="amisetting-menu">
                <div className="setting-main">
                  <h2 className="mb-4">
                    {frontLabelsName
                      ? frontLabelsName.filter((e) => e.key == "lbl_my_area")
                          .length > 0
                        ? frontLabelsName.filter(
                            (e) => e.key == "lbl_my_area",
                          )[0]["value"] || "lbl_my_area"
                        : "lbl_my_area"
                      : "lbl_my_area"}
                  </h2>
                </div>
                <div className="menu-sets-item">
                  <h2>
                    {frontLabelsName
                      ? frontLabelsName.filter(
                          (e) => e.key == "lbl_property_watch_enabled",
                        ).length > 0
                        ? frontLabelsName.filter(
                            (e) => e.key == "lbl_property_watch_enabled",
                          )[0]["value"] || "lbl_property_watch_enabled"
                        : "lbl_property_watch_enabled"
                      : "lbl_property_watch_enabled"}
                  </h2>

                  <div className="custom-check-main1">
                    {isLoading ? (
                      <Skeleton width={100} />
                    ) : (
                      <div className="dahboard-toggle-edit-section">
                        <div className="d-flex align-items-center">
                          <span className="switch-text me-1">
                            {frontLabelsName
                              ? frontLabelsName.filter((e) => e.key == "lbl_on")
                                  .length > 0
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_on",
                                  )[0]["value"] || "lbl_on"
                                : "lbl_on"
                              : "lbl_on"}
                          </span>

                          <Switch
                            isOn={!propertyWatchToggle}
                            handleToggle={() => handlePropertyWatchChange()}
                            disabled={false}
                            id={"react-switch-new-11"}
                          />
                          <span className="switch-text ms-1">
                            {frontLabelsName
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_off",
                                ).length > 0
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_off",
                                  )[0]["value"] || "lbl_off"
                                : "lbl_off"
                              : "lbl_off"}
                          </span>
                        </div>
                        <Link to={"/property-watch"}>
                          <button className="btn-edit ms-3">
                            <span>
                              {" "}
                              {frontLabelsName
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_edit",
                                  ).length > 0
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_edit",
                                    )[0]["value"] || "lbl_edit"
                                  : "lbl_edit"
                                : "lbl_edit"}{" "}
                            </span>
                          </button>
                        </Link>
                      </div>
                    )}
                  </div>
                </div>

                <div className="menu-sets-item">
                  <h2>
                    {frontLabel(frontLabelsName, "lbl_rental_listing_enabled")}
                  </h2>

                  <div className="custom-check-main1">
                    {isLoading ? (
                      <Skeleton width={100} />
                    ) : (
                      <div className="dahboard-toggle-edit-section">
                        <div className="d-flex align-items-center">
                          <span className="switch-text me-1">
                            {frontLabel(frontLabelsName, "lbl_on")}
                          </span>
                          <Switch
                            isOn={checked}
                            handleToggle={() => handleChange()}
                            disabled={false}
                            id={"react-switch-new-1"}
                          />
                          <span className="switch-text ms-1">
                            {frontLabel(frontLabelsName, "lbl_off")}
                          </span>
                        </div>
                        <Link to={"/update-renter-info"}>
                          <button className="btn-edit ms-3">
                            <span>
                              {frontLabel(frontLabelsName, "lbl_edit")}
                            </span>
                          </button>
                        </Link>
                      </div>
                    )}
                  </div>
                </div>

                <div className="menu-sets-item">
                  <h2>
                    {frontLabel(
                      frontLabelsName,
                      "lbl_tenant_information_configured",
                    )}
                  </h2>

                  <div className="custom-check-main1">
                    {isLoading && <Skeleton width={100} />}
                    {!isLoading && (
                      <div className="dahboard-toggle-edit-section">
                        {!isLoading && (
                          <div className="d-flex align-items-center">
                            <span className="switch-text me-1">
                              {frontLabel(frontLabelsName, "lbl_yes")}
                            </span>
                            <Switch
                              checked={
                                dashboardSubDetails?.tenant_configured == 1
                              }
                              disabled={true}
                            />
                            <span className="switch-text ms-1">
                              {frontLabel(frontLabelsName, "lbl_no")}
                            </span>
                          </div>
                        )}
                        <Link to={"/tenant-profile"}>
                          <button className="btn-edit ms-3">
                            <span>
                              {frontLabel(frontLabelsName, "lbl_edit")}
                            </span>
                          </button>
                        </Link>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="col-lg-3 col-md-12">
              <div className={`change-pwd-desc-dash ${isMobile ? "mt-4" : ""}`}>
                <Form>
                  <div className="text-center">
                    <h2 className="set-font-size1">Change Password</h2>
                  </div>

                  <div className="form">
                    <div className="form-item">
                      <input
                        type="text"
                        id="Password"
                        autocomplete="off"
                        value={oldPassword}
                        onChange={(e) => setOldPassword(e.target.value)}
                      />
                      <label for="Old Password"> Old Password</label>
                    </div>
                    <div className="form-item">
                      <input
                        type="text"
                        id="Password"
                        autocomplete="off"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                      />
                      <label for="New Password"> New Password</label>
                    </div>
                    <div className="form-item">
                      <input
                        type="text"
                        id="Password"
                        autocomplete="off"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                      />
                      <label for="Confirm New Password">
                        Confirm New Password
                      </label>
                    </div>
                    <div className="button-set-dash">
                      <Button onClick={handlePassword}>
                        Change my password
                      </Button>
                    </div>
                  </div>
                </Form>
              </div>
            </div> */}
          </div>
        </div>

        <div className="inchat-box">
          <div className="row pt-4">
            <div className="col-lg-6 col-md-12 active-properties-div">
              <Inbox />
              {(auth?.user?.rental_period == "" ||
                auth?.user?.rental_period == "expired") && (
                <div class="backdrop" style={{ zIndex: 0 }}>
                  <div className="popdiv ">
                    <Button
                      className="button-get-access"
                      onClick={() => handleSubscribe(allSubscription?._id)}
                    >
                      {frontLabelsName
                        ? frontLabelsName.filter(
                            (e) => e.key == "lbl_get_access",
                          ).length > 0
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_get_access",
                            )[0]["value"] || "lbl_get_access"
                          : "lbl_get_access"
                        : "lbl_get_access"}
                    </Button>
                  </div>
                </div>
              )}
            </div>

            <div className="col-lg-6 col-md-12 pt-3 active-properties-div">
              <div className="fr-chat-main">
                <div className="frs-chat-desc">
                  <h3>
                    {frontLabelsName
                      ? frontLabelsName.filter(
                          (e) => e.key == "lbl_active_properties",
                        ).length > 0
                        ? frontLabelsName.filter(
                            (e) => e.key == "lbl_active_properties",
                          )[0]["value"] || "lbl_active_properties"
                        : "lbl_active_properties"
                      : "lbl_active_properties"}
                  </h3>
                  <Link
                    to={
                      tabId === 1
                        ? "/favourite-properties"
                        : tabId === 2
                          ? "/properties"
                          : tabId === 3
                            ? "/hidden-properties"
                            : "/applied-properties"
                    }
                  >
                    {frontLabelsName
                      ? frontLabelsName.filter((e) => e.key == "lbl_see_all")
                          .length > 0
                        ? frontLabelsName.filter(
                            (e) => e.key == "lbl_see_all",
                          )[0]["value"] || "lbl_see_all"
                        : "lbl_see_all"
                      : "lbl_see_all"}
                  </Link>
                </div>
              </div>

              <div className="desc-ws-main">
                <div className="al-wslinks ">
                  <div className="row">
                    <div id="exTab1">
                      <ul className="nav nav-pills">
                        <li
                          className="active cus-dd alll-links-wss"
                          onClick={() => selectTab(1)}
                        >
                          {activeTab === true && tabId === 1 ? (
                            <img
                              src="assets/ionic-ios-heart.svg"
                              alt="Favourites"
                              className="dash-active-img-style"
                            />
                          ) : (
                            <img
                              src="assets/Icon ionic-ios-heart (1).svg"
                              alt="Favourites"
                              className="dash-active-img-style"
                            />
                          )}

                          <Link
                            to="#1a"
                            id="chk-tog"
                            data-toggle="tab"
                            className="main-sc"
                          >
                            {frontLabelsName
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_favourites",
                                ).length > 0
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_favourites",
                                  )[0]["value"] || "lbl_favourites"
                                : "lbl_favourites"
                              : "lbl_favourites"}
                          </Link>
                        </li>

                        <li
                          className="cus-dd alll-links-wss"
                          onClick={() => selectTab(2)}
                        >
                          {activeTab === true && tabId === 2 ? (
                            <img
                              src="assets/tabs/newproperties.svg"
                              alt="building"
                              className="dash-active-img-style"
                            />
                          ) : (
                            <img
                              src="assets/awesome-building.svg"
                              alt="building"
                              className="dash-active-img-style"
                            />
                          )}

                          <Link
                            to="#2a"
                            id="554"
                            data-toggle="tab"
                            className="link-color"
                          >
                            {frontLabelsName
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_new_properties",
                                ).length > 0
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_new_properties",
                                  )[0]["value"] || "lbl_new_properties"
                                : "lbl_new_properties"
                              : "lbl_new_properties"}
                          </Link>
                        </li>
                        <li
                          className="cus-dd alll-links-wss"
                          onClick={() => selectTab(3)}
                        >
                          {activeTab === true && tabId === 3 ? (
                            <img
                              src="assets/tabs/hiddenproperties.svg"
                              alt="Hidden"
                              className="dash-active-img-style"
                            />
                          ) : (
                            <img
                              src="assets/ionic-md-eye-off.svg"
                              alt="Hidden"
                              className="dash-active-img-style"
                            />
                          )}

                          <Link to="#3a" data-toggle="tab">
                            {frontLabelsName
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_hidden_properties",
                                ).length > 0
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_hidden_properties",
                                  )[0]["value"] || "lbl_hidden_properties"
                                : "lbl_hidden_properties"
                              : "lbl_hidden_properties"}
                          </Link>
                        </li>
                        <li
                          className="cus-dd alll-links-wss"
                          onClick={() => selectTab(4)}
                        >
                          {activeTab === true && tabId === 4 ? (
                            <img
                              src="assets/tabs/appliedproperties.svg"
                              alt="Applied"
                              className="dash-active-img-style"
                            />
                          ) : (
                            <img
                              src="assets/applied.svg"
                              alt="Applied"
                              className="dash-active-img-style"
                            />
                          )}

                          <Link to="#4a" data-toggle="tab">
                            {frontLabelsName
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_applied_properties",
                                ).length > 0
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_applied_properties",
                                  )[0]["value"] || "lbl_applied_properties"
                                : "lbl_applied_properties"
                              : "lbl_applied_properties"}
                          </Link>
                        </li>
                      </ul>

                      <div className="tab-content clearfix">
                        <div className="tab-pane active" id="1a">
                          {loading ? (
                            <DashboardTableLoader />
                          ) : (
                            favorite?.docs?.length > 0 &&
                            favorite?.docs?.map((obj, index) => (
                              <div className="row noneDecor">
                                <Link
                                  to={`/property-details/${obj.propertyData?._id}`}
                                >
                                  <div className="col-lg-12 col-sm-12">
                                    <div className="favourite-white-box mt-2">
                                      <div className="my-favourite-box">
                                        <div className="row dash-row-style">
                                          <div
                                            className="col-lg-2 col-sm-2 col-xs-12 align-self-center"
                                            key={index}
                                          >
                                            <img
                                              src={
                                                obj?.propertyData?.cover_photo
                                                  ? obj?.propertyData
                                                      ?.cover_photo
                                                  : obj?.propertyData
                                                      ?.photo_gallery[0]
                                              }
                                              alt="user-notification"
                                              className="favorate-img pe-2"
                                            />
                                          </div>
                                          <div className="col-lg-9 col-sm-9 col-xs-11 mt-lg-0 mt-md-2  favourate-message-col">
                                            <div className="align-item-center">
                                              <p className="favourite-text">
                                                {obj?.propertyData?.location}
                                              </p>
                                            </div>
                                            {expand === true &&
                                            expandId === obj?._id ? (
                                              <div className="favourite-subtext truncate-overflow">
                                                {obj?.propertyData?.description}
                                                <a
                                                  className="anchorTag"
                                                  onClick={() =>
                                                    handleExpand(false, null)
                                                  }
                                                >
                                                  ...
                                                  {frontLabelsName
                                                    ? frontLabelsName.filter(
                                                        (e) =>
                                                          e.key ==
                                                          "lbl_read_less",
                                                      ).length > 0
                                                      ? frontLabelsName.filter(
                                                          (e) =>
                                                            e.key ==
                                                            "lbl_read_less",
                                                        )[0]["value"] ||
                                                        "lbl_read_less"
                                                      : "lbl_read_less"
                                                    : "lbl_read_less"}
                                                </a>
                                              </div>
                                            ) : (
                                              <div className="favourite-subtext truncate-overflow">
                                                {trimString(
                                                  obj?.propertyData
                                                    ?.description,
                                                  240,
                                                )}
                                                {obj?.propertyData?.description
                                                  .length > 240 && (
                                                  <a
                                                    className="anchorTag"
                                                    onClick={() =>
                                                      handleExpand(
                                                        true,
                                                        obj?._id,
                                                      )
                                                    }
                                                  >
                                                    {frontLabelsName
                                                      ? frontLabelsName.filter(
                                                          (e) =>
                                                            e.key ==
                                                            "lbl_read_more",
                                                        ).length > 0
                                                        ? frontLabelsName.filter(
                                                            (e) =>
                                                              e.key ==
                                                              "lbl_read_more",
                                                          )[0]["value"] ||
                                                          "lbl_read_more"
                                                        : "lbl_read_more"
                                                      : "lbl_read_more"}
                                                  </a>
                                                )}
                                              </div>
                                            )}
                                          </div>
                                          <div className="col-lg-1  col-sm-1 col-xs-1 mt-lg-0 mt-md-2  d-flex justify-content-end favourate-image-col">
                                            <img
                                              src={"assets/yellohreat.svg"}
                                              alt="hshshs"
                                              width="20px"
                                              height="20px"
                                              onClick={(e) => {
                                                unlike(obj);
                                                e.preventDefault();
                                                e.stopPropagation();
                                              }}
                                              style={{
                                                cursor: "pointer",
                                              }}
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </Link>
                              </div>
                            ))
                          )}

                          {!loading && favorite?.docs?.length === 0 && (
                            <div className="no-properties-found">
                              {frontLabelsName
                                ? frontLabelsName.filter(
                                    (e) =>
                                      e.key ==
                                      "lbl_no_favorite_properties_found",
                                  ).length > 0
                                  ? frontLabelsName.filter(
                                      (e) =>
                                        e.key ==
                                        "lbl_no_favorite_properties_found",
                                    )[0]["value"] ||
                                    "lbl_no_favorite_properties_found"
                                  : "lbl_no_favorite_properties_found"
                                : "lbl_no_favorite_properties_found"}
                            </div>
                          )}
                        </div>
                        <div className="tab-pane" id="2a">
                          {loading ? (
                            <DashboardTableLoader />
                          ) : property.docs.length > 0 ? (
                            property.docs.map((list, index) => (
                              <div className="row noneDecor" key={index}>
                                <Link to={`/property-details/${list._id}`}>
                                  <div className="col-lg-12 col-sm-12">
                                    <div className="favourite-white-box mt-2">
                                      <div className="my-favourite-box">
                                        <div className="row dash-row-style">
                                          <div className="col-lg-2 col-sm-2 col-xs-12 align-self-center">
                                            <img
                                              src={
                                                list.photo_gallery.length > 0
                                                  ? list.photo_gallery[0]
                                                  : list.cover_photo
                                              }
                                              alt="user-notification"
                                              className="favorate-img"
                                            />
                                          </div>
                                          <div className="col-lg-9 col-sm-9 col-xs-11 mt-lg-0 mt-md-2  favourate-message-col">
                                            <div className="align-item-center">
                                              <p className="favourite-text">
                                                {list?.location}
                                              </p>
                                            </div>

                                            {expand === true &&
                                            expandId === index ? (
                                              <div className="favourite-subtext truncate-overflow">
                                                {list.description}
                                                <a
                                                  className="anchorTag"
                                                  onClick={() =>
                                                    handleExpand(false, null)
                                                  }
                                                >
                                                  ...
                                                  {frontLabelsName
                                                    ? frontLabelsName.filter(
                                                        (e) =>
                                                          e.key ==
                                                          "lbl_read_less",
                                                      ).length > 0
                                                      ? frontLabelsName.filter(
                                                          (e) =>
                                                            e.key ==
                                                            "lbl_read_less",
                                                        )[0]["value"] ||
                                                        "lbl_read_less"
                                                      : "lbl_read_less"
                                                    : "lbl_read_less"}
                                                </a>
                                              </div>
                                            ) : (
                                              <div className="favourite-subtext">
                                                {trimString(
                                                  list.description,
                                                  200,
                                                )}
                                                {list.description.length >
                                                  200 && (
                                                  <a
                                                    className="anchorTag"
                                                    onClick={() =>
                                                      handleExpand(true, index)
                                                    }
                                                  >
                                                    {frontLabelsName
                                                      ? frontLabelsName.filter(
                                                          (e) =>
                                                            e.key ==
                                                            "lbl_read_more",
                                                        ).length > 0
                                                        ? frontLabelsName.filter(
                                                            (e) =>
                                                              e.key ==
                                                              "lbl_read_more",
                                                          )[0]["value"] ||
                                                          "lbl_read_more"
                                                        : "lbl_read_more"
                                                      : "lbl_read_more"}
                                                  </a>
                                                )}
                                              </div>
                                            )}
                                          </div>
                                          <div className="col-lg-1  col-sm-1 col-xs-1 mt-lg-0 mt-md-2  d-flex justify-content-end favourate-image-col">
                                            {/* <img
                                            src={
                                              showWatch
                                                ? "assets/yellohreat.svg"
                                                : "assets/unfav.svg"
                                            }
                                            alt="hshshs"
                                            width="20px"
                                            height="20px"
                                            onClick={() =>
                                              setShowWatch(!showWatch)
                                            }
                                          /> */}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </Link>
                              </div>
                            ))
                          ) : loading ? (
                            <Loading />
                          ) : (
                            property.docs.length === 0 && (
                              <div className="no-properties-found">
                                {frontLabelsName
                                  ? frontLabelsName.filter(
                                      (e) =>
                                        e.key ==
                                        "lbl_no_favorite_properties_found",
                                    ).length > 0
                                    ? frontLabelsName.filter(
                                        (e) =>
                                          e.key ==
                                          "lbl_no_favorite_properties_found",
                                      )[0]["value"] ||
                                      "lbl_no_favorite_properties_found"
                                    : "lbl_no_favorite_properties_found"
                                  : "lbl_no_favorite_properties_found"}
                              </div>
                            )
                          )}
                        </div>
                        <div className="tab-pane" id="3a">
                          {loading ? (
                            <DashboardTableLoader />
                          ) : (
                            hidden?.docs?.length > 0 &&
                            hidden?.docs?.map((data, index) => (
                              <div className="row noneDecor">
                                <Link
                                  to={`/property-details/${data.propertyData?._id}`}
                                >
                                  <div
                                    className="col-lg-12 col-sm-12"
                                    key={index}
                                  >
                                    <div className="favourite-white-box mt-2">
                                      <div className="my-favourite-box">
                                        <div className="row dash-row-style">
                                          <div className="col-lg-2 col-sm-2 col-xs-12 align-self-center">
                                            <img
                                              src={
                                                data?.propertyData?.cover_photo
                                                  ? data?.propertyData
                                                      ?.cover_photo
                                                  : data?.propertyData
                                                      ?.photo_gallery[0]
                                              }
                                              alt="user-notification"
                                              className="favorate-img"
                                            />
                                          </div>
                                          <div className="col-lg-9 col-sm-9 col-xs-11 mt-lg-0 mt-md-2  favourate-message-col">
                                            <div className="align-item-center">
                                              <p className="favourite-text">
                                                {data?.propertyData?.location}
                                              </p>
                                            </div>

                                            {expand === true &&
                                            expandId === data?._id ? (
                                              <div className="favourite-subtext truncate-overflow">
                                                {
                                                  data?.propertyData
                                                    ?.description
                                                }
                                                <a
                                                  className="anchorTag"
                                                  onClick={() =>
                                                    handleExpand(false, null)
                                                  }
                                                >
                                                  ...
                                                  {frontLabelsName
                                                    ? frontLabelsName.filter(
                                                        (e) =>
                                                          e.key ==
                                                          "lbl_read_less",
                                                      ).length > 0
                                                      ? frontLabelsName.filter(
                                                          (e) =>
                                                            e.key ==
                                                            "lbl_read_less",
                                                        )[0]["value"] ||
                                                        "lbl_read_less"
                                                      : "lbl_read_less"
                                                    : "lbl_read_less"}
                                                </a>
                                              </div>
                                            ) : (
                                              <div className="favourite-subtext truncate-overflow">
                                                {trimString(
                                                  data?.propertyData
                                                    ?.description,
                                                  240,
                                                )}
                                                {data?.propertyData?.description
                                                  .length > 240 && (
                                                  <a
                                                    className="anchorTag"
                                                    onClick={() =>
                                                      handleExpand(
                                                        true,
                                                        data?._id,
                                                      )
                                                    }
                                                  >
                                                    {frontLabelsName
                                                      ? frontLabelsName.filter(
                                                          (e) =>
                                                            e.key ==
                                                            "lbl_read_more",
                                                        ).length > 0
                                                        ? frontLabelsName.filter(
                                                            (e) =>
                                                              e.key ==
                                                              "lbl_read_more",
                                                          )[0]["value"] ||
                                                          "lbl_read_more"
                                                        : "lbl_read_more"
                                                      : "lbl_read_more"}
                                                  </a>
                                                )}
                                              </div>
                                            )}
                                          </div>
                                          <div className="col-lg-1  col-sm-1 col-xs-1 mt-lg-0 mt-md-2  d-flex justify-content-end favourate-image-col">
                                            <img
                                              src={"assets/hid.svg"}
                                              alt="hshshs"
                                              width="20px"
                                              height="20px"
                                              style={{
                                                cursor: "pointer",
                                              }}
                                              onClick={(e) => {
                                                hide(data);
                                                e.preventDefault();
                                                e.stopPropagation();
                                              }}
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </Link>
                              </div>
                            ))
                          )}
                          {!loading && hidden?.docs?.length === 0 && (
                            <div className="no-properties-found">
                              {frontLabelsName
                                ? frontLabelsName.filter(
                                    (e) =>
                                      e.key == "lbl_no_hidden_properties_found",
                                  ).length > 0
                                  ? frontLabelsName.filter(
                                      (e) =>
                                        e.key ==
                                        "lbl_no_hidden_properties_found",
                                    )[0]["value"] ||
                                    "lbl_no_hidden_properties_found"
                                  : "lbl_no_hidden_properties_found"
                                : "lbl_no_hidden_properties_found"}
                            </div>
                          )}
                        </div>
                        <div className="tab-pane" id="4a">
                          {loading ? (
                            <DashboardTableLoader />
                          ) : (
                            appProperty?.docs?.length > 0 &&
                            appProperty?.docs?.map((useObj, index) => (
                              <div className="row noneDecor">
                                <Link
                                  to={`/property-details/${useObj.property._id}`}
                                >
                                  <div
                                    className="col-lg-12 col-sm-12"
                                    key={index}
                                  >
                                    <div className="favourite-white-box mt-2">
                                      <div className="my-favourite-box">
                                        <div className="row dash-row-style">
                                          <div className="col-lg-2 col-sm-2 col-xs-12 align-self-center">
                                            <img
                                              src={
                                                useObj?.property?.cover_photo
                                                  ? useObj?.property
                                                      ?.cover_photo
                                                  : useObj?.property
                                                      ?.photo_gallery[0]
                                              }
                                              alt="user-notification"
                                              className="favorate-img"
                                            />
                                          </div>
                                          <div className="col-lg-9 col-sm-9 col-xs-11 mt-lg-0 mt-md-2  favourate-message-col">
                                            <div className="align-item-center">
                                              <p className="favourite-text">
                                                {useObj?.property?.location}
                                              </p>
                                            </div>

                                            {expand === true &&
                                            expandId === useObj?._id ? (
                                              <div className="favourite-subtext truncate-overflow">
                                                {useObj?.property?.description}
                                                <a
                                                  className="anchorTag"
                                                  onClick={() =>
                                                    handleExpand(false, null)
                                                  }
                                                >
                                                  ...
                                                  {frontLabelsName
                                                    ? frontLabelsName.filter(
                                                        (e) =>
                                                          e.key ==
                                                          "lbl_read_less",
                                                      ).length > 0
                                                      ? frontLabelsName.filter(
                                                          (e) =>
                                                            e.key ==
                                                            "lbl_read_less",
                                                        )[0]["value"] ||
                                                        "lbl_read_less"
                                                      : "lbl_read_less"
                                                    : "lbl_read_less"}
                                                </a>
                                              </div>
                                            ) : (
                                              <div className="favourite-subtext truncate-overflow">
                                                {trimString(
                                                  useObj?.property?.description,
                                                  240,
                                                )}
                                                {useObj?.property?.description
                                                  .length > 240 && (
                                                  <a
                                                    className="anchorTag"
                                                    onClick={() =>
                                                      handleExpand(
                                                        true,
                                                        useObj?._id,
                                                      )
                                                    }
                                                  >
                                                    {frontLabelsName
                                                      ? frontLabelsName.filter(
                                                          (e) =>
                                                            e.key ==
                                                            "lbl_read_more",
                                                        ).length > 0
                                                        ? frontLabelsName.filter(
                                                            (e) =>
                                                              e.key ==
                                                              "lbl_read_more",
                                                          )[0]["value"] ||
                                                          "lbl_read_more"
                                                        : "lbl_read_more"
                                                      : "lbl_read_more"}
                                                  </a>
                                                )}
                                              </div>
                                            )}
                                          </div>
                                          <div className="col-lg-1  col-sm-1 col-xs-1 mt-lg-0 mt-md-2  d-flex justify-content-end favourate-image-col">
                                            <img
                                              src={
                                                "assets/applyforaproperty.svg"
                                              }
                                              alt="hshshs"
                                              width="20px"
                                              height="20px"
                                              style={{
                                                cursor: "pointer",
                                              }}
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </Link>
                              </div>
                            ))
                          )}
                          {!loading && appProperty?.docs?.length === 0 && (
                            <div className="no-properties-found">
                              {frontLabelsName
                                ? frontLabelsName.filter(
                                    (e) =>
                                      e.key ==
                                      "lbl_no_applied_properties_found",
                                  ).length > 0
                                  ? frontLabelsName.filter(
                                      (e) =>
                                        e.key ==
                                        "lbl_no_applied_properties_found",
                                    )[0]["value"] ||
                                    "lbl_no_applied_properties_found"
                                  : "lbl_no_applied_properties_found"
                                : "lbl_no_applied_properties_found"}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {runningsubscriptions?.message ==
                "Your subscription is expired." && (
                <div class="backdrop" style={{ zIndex: 0 }}>
                  <div className="popdiv ">
                    <Button
                      className="button-get-access"
                      onClick={() => handleSubscribe(allSubscription?._id)}
                    >
                      {frontLabelsName
                        ? frontLabelsName.filter(
                            (e) => e.key == "lbl_get_access",
                          ).length > 0
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_get_access",
                            )[0]["value"] || "lbl_get_access"
                          : "lbl_get_access"
                        : "lbl_get_access"}
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="inchat-box">
          <div className="row pt-4">
            <div className="col-lg-6 col-md-12 active-properties-div">
              <div className="fr-chat-main">
                <div className="frs-chat-desc">
                  <h3>
                    {frontLabelsName
                      ? frontLabelsName.filter(
                          (e) => e.key == "lbl_property_watch",
                        ).length > 0
                        ? frontLabelsName.filter(
                            (e) => e.key == "lbl_property_watch",
                          )[0]["value"] || "lbl_property_watch"
                        : "lbl_property_watch"
                      : "lbl_property_watch"}
                  </h3>
                  <div className="d-flex align-items-center pe-2">
                    {isLoading ? (
                      <Skeleton width={100} />
                    ) : (
                      <>
                        <span
                          className="switch-text me-1"
                          style={{ color: "#fff" }}
                        >
                          {frontLabelsName
                            ? frontLabelsName.filter((e) => e.key == "lbl_on")
                                .length > 0
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_on",
                                )[0]["value"] || "lbl_on"
                              : "lbl_on"
                            : "lbl_on"}
                        </span>

                        <Switch
                          isOn={!propertyWatchToggle}
                          handleToggle={() => handlePropertyWatchChange()}
                          disabled={false}
                          id={"react-switch-new-11"}
                        />
                        <span
                          className="switch-text ms-1"
                          style={{ color: "#fff" }}
                        >
                          {frontLabelsName
                            ? frontLabelsName.filter((e) => e.key == "lbl_off")
                                .length > 0
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_off",
                                )[0]["value"] || "lbl_off"
                              : "lbl_off"
                            : "lbl_off"}
                        </span>
                      </>
                    )}
                  </div>
                </div>
              </div>

              <div className="wish-main-kk">
                <div className=" list-wish-des d-flex property-matching1">
                  <p>
                    <li
                      className={
                        watchTabId === 1 && activeTab === true
                          ? "active2 cus-dd alll-links-wss"
                          : "cus-dd alll-links-wss"
                      }
                      onClick={() => selectwatchListTab(1)}
                    >
                      <Link
                        to="#1b"
                        id="chk-tog"
                        data-toggle="tab"
                        className="watchlisttab"
                        // className="active-list"
                        // className="main-sc"
                      >
                        {frontLabelsName
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_summary_of_criteria",
                            ).length > 0
                            ? frontLabelsName.filter(
                                (e) => e.key == "lbl_summary_of_criteria",
                              )[0]["value"] || "lbl_summary_of_criteria"
                            : "lbl_summary_of_criteria"
                          : "lbl_summary_of_criteria"}
                      </Link>
                    </li>
                  </p>
                  <p>
                    <li
                      className={
                        watchTabId === 2 && activeTab === true
                          ? "active2 cus-dd alll-links-wss"
                          : " cus-dd alll-links-wss"
                      }
                      onClick={() => selectwatchListTab(2)}
                    >
                      <Link
                        to="#2b"
                        data-toggle="tab"
                        id="chk-tog"
                        onClick={HandleClick}
                      >
                        {frontLabelsName
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_properties_matching",
                            ).length > 0
                            ? frontLabelsName.filter(
                                (e) => e.key == "lbl_properties_matching",
                              )[0]["value"] || "lbl_properties_matching"
                            : "lbl_properties_matching"
                          : "lbl_properties_matching"}
                      </Link>
                    </li>
                  </p>
                  {watchTabId === 1 && (
                    <p
                      className="new-propert-watch-switch"
                      style={{
                        marginLeft: "auto",
                        marginRight: "20px",
                      }}
                    >
                      <button onClick={() => history.push("/property-watch")}>
                        {frontLabelsName
                          ? frontLabelsName.filter((e) => e.key == "lbl_edit")
                              .length > 0
                            ? frontLabelsName.filter(
                                (e) => e.key == "lbl_edit",
                              )[0]["value"] || "lbl_edit"
                            : "lbl_edit"
                          : "lbl_edit"}
                      </button>
                    </p>
                  )}
                </div>

                <div className="">
                  <div className="tab-content clearfix">
                    {watchTabId === 1 && (
                      <div className="tabactive tab-pane active" id="1b">
                        <div className="wa-box-main mt-0 mb-0">
                          <div className="row align-items-center">
                            {/* <div className="col-lg-3 col-md-3 min-width-dash">
                              <div className="pr-watch ps-0">
                                <p
                                  className="cus-pdd-cd"
                                  style={{ minWidth: "110px" }}
                                >
                                  <Link to="#">
                                    {frontLabelsName
                                      ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_property_watch"
                                      ).length > 0
                                        ? frontLabelsName.filter(
                                          (e) => e.key == "lbl_property_watch"
                                        )[0]["value"] || "lbl_property_watch"
                                        : "lbl_property_watch"
                                      : "lbl_property_watch"}
                                  </Link>
                                </p>
                              </div>
                            </div> */}
                            <div className="col-lg-9 col-md-9 min-width-dash1 ps-0">
                              <div className="d-flex align-items-center justify-content-center mobile-hhn-set">
                                <div className="col-lg-12 col-md-12 d-flex align-items-center flex-wrap">
                                  <div className="col-lg-6 col-md-6">
                                    <div className="pr-watch">
                                      <p>
                                        <label className="custom-radio">
                                          <input
                                            name="propertyWatch"
                                            id="propertyWatchb"
                                            type="radio"
                                            value={propertyWatch}
                                            onChange={(e) =>
                                              HandleWatchList(e, 4)
                                            }
                                            checked={
                                              propertyWatch == true
                                                ? true
                                                : false
                                            }
                                            className="new-radio"
                                          />
                                          <span class="checkmark"></span>
                                          <span>
                                            {frontLabelsName
                                              ? frontLabelsName.filter(
                                                  (e) =>
                                                    e.key ==
                                                    "lbl_property_watch_is_on",
                                                ).length > 0
                                                ? frontLabelsName.filter(
                                                    (e) =>
                                                      e.key ==
                                                      "lbl_property_watch_is_on",
                                                  )[0]["value"] ||
                                                  "lbl_property_watch_is_on"
                                                : "lbl_property_watch_is_on"
                                              : "lbl_property_watch_is_on"}
                                          </span>
                                        </label>
                                      </p>
                                    </div>
                                  </div>
                                  <div className="col-lg-6 col-md-6">
                                    <div className="pr-watch">
                                      <p>
                                        <label className="custom-radio">
                                          <input
                                            name="propertyWatch"
                                            id="propertyWatcha"
                                            type="radio"
                                            value={propertyWatch}
                                            onChange={(e) =>
                                              HandleWatchList(e, 5)
                                            }
                                            checked={
                                              propertyWatch == false
                                                ? true
                                                : false
                                            }
                                            className="new-radio"
                                          />
                                          <span class="checkmark"></span>
                                          <span>
                                            {frontLabelsName
                                              ? frontLabelsName.filter(
                                                  (e) =>
                                                    e.key ==
                                                    "lbl_property_watch_is_off",
                                                ).length > 0
                                                ? frontLabelsName.filter(
                                                    (e) =>
                                                      e.key ==
                                                      "lbl_property_watch_is_off",
                                                  )[0]["value"] ||
                                                  "lbl_property_watch_is_off"
                                                : "lbl_property_watch_is_off"
                                              : "lbl_property_watch_is_off"}
                                          </span>
                                        </label>
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-12 col-md-12">
                              <div className="bsc-main-title">
                                <p>
                                  {/* The Property Monitor monitors properties that match your wishes for a property to rent */}
                                  {frontLabelsName
                                    ? frontLabelsName.filter(
                                        (e) =>
                                          e.key ==
                                          "lbl_monitor_properties_match_wishes",
                                      ).length > 0
                                      ? frontLabelsName.filter(
                                          (e) =>
                                            e.key ==
                                            "lbl_monitor_properties_match_wishes",
                                        )[0]["value"] ||
                                        "lbl_monitor_properties_match_wishes"
                                      : "lbl_monitor_properties_match_wishes"
                                    : "lbl_monitor_properties_match_wishes"}
                                </p>
                              </div>
                              <div className="">
                                <div className="row">
                                  <div className="col-lg-4 col-md-4 pe-0">
                                    <div className="history-dsc pe-0">
                                      <p className="word">
                                        <strong>
                                          {" "}
                                          {frontLabelsName
                                            ? frontLabelsName.filter(
                                                (e) => e.key == "lbl_type",
                                              ).length > 0
                                              ? frontLabelsName.filter(
                                                  (e) => e.key == "lbl_type",
                                                )[0]["value"] || "lbl_type"
                                              : "lbl_type"
                                            : "lbl_type"}
                                          :{" "}
                                        </strong>
                                        {/* <br /> */}
                                        {propertyWatchLoading ? (
                                          <Skeleton width={100} />
                                        ) : (
                                          propertyWatchData?.propertyType
                                            ?.length > 0 &&
                                          getTypeName(
                                            propertyWatchData?.propertyType,
                                          )
                                        )}
                                      </p>
                                    </div>
                                  </div>
                                  <div className="col-lg-4 col-md-4">
                                    <div className="history-dsc">
                                      <p className="word">
                                        <strong>
                                          {" "}
                                          {frontLabelsName
                                            ? frontLabelsName.filter(
                                                (e) => e.key == "lbl_room",
                                              ).length > 0
                                              ? frontLabelsName.filter(
                                                  (e) => e.key == "lbl_room",
                                                )[0]["value"] || "lbl_room"
                                              : "lbl_room"
                                            : "lbl_room"}
                                          :{" "}
                                        </strong>
                                        {/* <br /> */}
                                        {propertyWatchLoading ? (
                                          <Skeleton width={100} />
                                        ) : (
                                          propertyWatchData?.bhk?.length > 0 &&
                                          propertyWatchData?.bhk?.toString()
                                        )}{" "}
                                      </p>
                                    </div>
                                  </div>
                                  <div className="col-lg-4 col-md-4">
                                    <div className="history-dsc">
                                      <p className="word">
                                        <strong>
                                          {" "}
                                          {frontLabelsName
                                            ? frontLabelsName.filter(
                                                (e) => e.key == "lbl_zip_code",
                                              ).length > 0
                                              ? frontLabelsName.filter(
                                                  (e) =>
                                                    e.key == "lbl_zip_code",
                                                )[0]["value"] || "lbl_zip_code"
                                              : "lbl_zip_code"
                                            : "lbl_zip_code"}
                                          :{" "}
                                        </strong>

                                        {propertyWatchLoading ? (
                                          <Skeleton width={100} />
                                        ) : (
                                          propertyWatchData?.area?.length > 0 &&
                                          propertyWatchData?.area?.[0] != 0 &&
                                          propertyWatchData?.area?.toString()
                                        )}
                                      </p>
                                    </div>
                                  </div>
                                  {/* <div className="col-lg-3 col-md-3 pe-0">
                                    <div className="history-dsc custom-add-right-border">
                                      <p>
                                        <strong>
                                          {frontLabelsName
                                            ? frontLabelsName.filter(
                                              (e) =>
                                                e.key ==
                                                "lbl_message_sent_with"
                                            ).length > 0
                                              ? frontLabelsName.filter(
                                                (e) =>
                                                  e.key ==
                                                  "lbl_message_sent_with"
                                              )[0]["value"] ||
                                              "lbl_message_sent_with"
                                              : "lbl_message_sent_with"
                                            : "lbl_message_sent_with"}
                                          :{" "}
                                        </strong>
                                      </p>
                                      <div className="new3">
                                        <form className="d-flex flex-column">
                                          <div className="form-group new-color-add">
                                            <input
                                              type="checkbox"
                                              id="Email"
                                              name="email"
                                              checked={propertyWatchData?.user?.property_watch_email}
                                              value={propertyWatchData?.user?.property_watch_email}
                                              onChange={(e) =>
                                                HandleWatchList(e, 1)
                                              }
                                            />
                                            <label for="Email" >
                                              {frontLabelsName
                                                ? frontLabelsName.filter(
                                                  (e) => e.key == "lbl_email"
                                                ).length > 0
                                                  ? frontLabelsName.filter(
                                                    (e) =>
                                                      e.key == "lbl_email"
                                                  )[0]["value"] || "lbl_email"
                                                  : "lbl_email"
                                                : "lbl_email"}


                                            </label>
                                          </div>
                                          <div className="form-group new-color-add">
                                            <input
                                              type="checkbox"
                                              id="sms"
                                              name="sms"
                                              checked={propertyWatchData?.user?.property_watch_sms}
                                              value={propertyWatchData?.user?.property_watch_sms}
                                              onChange={(e) => HandleWatchList(e, 2)}
                                              className="advanced-checkbox input_style form-check-input"
                                            />
                                            <label for="sms">
                                              {frontLabelsName
                                                ? frontLabelsName.filter(
                                                  (e) => e.key == "lbl_sms"
                                                ).length > 0
                                                  ? frontLabelsName.filter(
                                                    (e) => e.key == "lbl_sms"
                                                  )[0]["value"] || "lbl_sms"
                                                  : "lbl_sms"
                                                : "lbl_sms"}
                                            </label>
                                          </div>
                                          <div className="form-group new-color-add">
                                            <input
                                              type="checkbox"
                                              id="web"
                                              name="web"
                                              checked={propertyWatchData?.user?.property_watch_web}
                                              value={propertyWatchData?.user?.property_watch_web}
                                              onChange={(e) =>
                                                HandleWatchList(e, 3)
                                              }
                                            />
                                            <label for="web">
                                              {frontLabelsName
                                                ? frontLabelsName.filter(
                                                  (e) => e.key == "lbl_web"
                                                ).length > 0
                                                  ? frontLabelsName.filter(
                                                    (e) => e.key == "lbl_web"
                                                  )[0]["value"] || "lbl_web"
                                                  : "lbl_web"
                                                : "lbl_web"}
                                            </label>
                                          </div>
                                        </form>
                                      </div>
                                    </div>
                                  </div> */}
                                </div>
                                <div className="row">
                                  <div className="col-lg-4 col-md-4">
                                    <div className="history-dsc">
                                      <p>
                                        <strong>
                                          {/* {frontLabelsName
                                            ? frontLabelsName.filter(
                                                (e) =>
                                                  e.key ==
                                                  "lbl_availability_type"
                                              ).length > 0
                                              ? frontLabelsName.filter(
                                                  (e) =>
                                                    e.key ==
                                                    "lbl_availability_type"
                                                )[0]["value"] ||
                                                "lbl_availability_type"
                                              : "lbl_availability_type"
                                            : "lbl_availability_type"}
                                          :{" "} */}
                                          {frontLabelsName
                                            ? frontLabelsName.filter(
                                                (e) =>
                                                  e.key == "lbl_rental_period",
                                              ).length > 0
                                              ? frontLabelsName.filter(
                                                  (e) =>
                                                    e.key ==
                                                    "lbl_rental_period",
                                                )[0]["value"] ||
                                                "lbl_rental_period"
                                              : "lbl_rental_period"
                                            : "lbl_rental_period"}
                                          :{" "}
                                        </strong>

                                        {propertyWatchLoading ? (
                                          <Skeleton width={100} />
                                        ) : (
                                          propertyWatchData?.availabilityType ===
                                            "shortTerm" &&
                                          (frontLabelsName
                                            ? frontLabelsName.filter(
                                                (e) =>
                                                  e.key == "lbl_short_term",
                                              ).length > 0
                                              ? frontLabelsName.filter(
                                                  (e) =>
                                                    e.key == "lbl_short_term",
                                                )[0]["value"] ||
                                                "lbl_short_term"
                                              : "lbl_short_term"
                                            : "lbl_short_term")
                                        )}
                                        {propertyWatchData?.availabilityType ===
                                          "longTerm" &&
                                          (frontLabelsName
                                            ? frontLabelsName.filter(
                                                (e) => e.key == "lbl_long_term",
                                              ).length > 0
                                              ? frontLabelsName.filter(
                                                  (e) =>
                                                    e.key == "lbl_long_term",
                                                )[0]["value"] || "lbl_long_term"
                                              : "lbl_long_term"
                                            : "lbl_long_term")}
                                      </p>
                                    </div>
                                    <div className="history-dsc ">
                                      <p className="d-flex align-items-center">
                                        <strong>
                                          {frontLabelsName
                                            ? frontLabelsName.filter(
                                                (e) =>
                                                  e.key == "lbl_size_range",
                                              ).length > 0
                                              ? frontLabelsName.filter(
                                                  (e) =>
                                                    e.key == "lbl_size_range",
                                                )[0]["value"] ||
                                                "lbl_size_range"
                                              : "lbl_size_range"
                                            : "lbl_size_range"}
                                          : &nbsp;
                                        </strong>
                                        {propertyWatchLoading ? (
                                          <Skeleton width={100} />
                                        ) : propertyWatchData?.propertySizeStart !=
                                          null ? (
                                          priceFormat(
                                            propertyWatchData?.propertySizeStart,
                                          )
                                        ) : (
                                          ""
                                        )}
                                        &nbsp;-&nbsp;
                                        {propertyWatchLoading
                                          ? ""
                                          : propertyWatchData?.propertySizeEnd
                                            ? priceFormat(
                                                propertyWatchData?.propertySizeEnd,
                                              )
                                            : ""}{" "}
                                        {!propertyWatchLoading && (
                                          <span>
                                            &nbsp;m<sup>2</sup>
                                          </span>
                                        )}
                                      </p>
                                    </div>
                                  </div>
                                  <div className="col-lg-4 col-md-4">
                                    <div className="history-dsc">
                                      <p>
                                        <strong>
                                          {frontLabelsName
                                            ? frontLabelsName.filter(
                                                (e) =>
                                                  e.key == "lbl_available_from",
                                              ).length > 0
                                              ? frontLabelsName.filter(
                                                  (e) =>
                                                    e.key ==
                                                    "lbl_available_from",
                                                )[0]["value"] ||
                                                "lbl_available_from"
                                              : "lbl_available_from"
                                            : "lbl_available_from"}
                                          :{" "}
                                        </strong>
                                        {/* <br /> */}
                                        {propertyWatchLoading ? (
                                          <Skeleton width={100} />
                                        ) : (
                                          propertyWatchData?.availabilityFrom &&
                                          moment(
                                            propertyWatchData?.availabilityFrom,
                                          ).format("DD/MM/YYYY")
                                        )}
                                      </p>
                                    </div>
                                    <div className="history-dsc">
                                      <p>
                                        {propertyWatchLoading ? (
                                          <Skeleton width={100} />
                                        ) : (
                                          propertyWatchData?.availabilityType ==
                                            "shortTerm" && (
                                            <p>
                                              <strong>
                                                {frontLabelsName
                                                  ? frontLabelsName.filter(
                                                      (e) =>
                                                        e.key ==
                                                        "lbl_available_to",
                                                    ).length > 0
                                                    ? frontLabelsName.filter(
                                                        (e) =>
                                                          e.key ==
                                                          "lbl_available_to",
                                                      )[0]["value"] ||
                                                      "lbl_available_to"
                                                    : "lbl_available_to"
                                                  : "lbl_available_to"}
                                                :{" "}
                                              </strong>{" "}
                                              {/* <br /> */}
                                              {propertyWatchData?.availabilityTo &&
                                                moment(
                                                  propertyWatchData?.availabilityTo,
                                                ).format("DD/MM/YYYY")}
                                            </p>
                                          )
                                        )}
                                      </p>
                                    </div>
                                    <div className="history-dsc ">
                                      <p>
                                        <strong>
                                          {frontLabelsName
                                            ? frontLabelsName.filter(
                                                (e) =>
                                                  e.key == "lbl_price_range",
                                              ).length > 0
                                              ? frontLabelsName.filter(
                                                  (e) =>
                                                    e.key == "lbl_price_range",
                                                )[0]["value"] ||
                                                "lbl_price_range"
                                              : "lbl_price_range"
                                            : "lbl_price_range"}
                                          :{" "}
                                        </strong>
                                        {propertyWatchLoading ? (
                                          <Skeleton width={100} />
                                        ) : propertyWatchData?.priceFrom !=
                                          null ? (
                                          priceFormat(
                                            propertyWatchData?.priceFrom,
                                          )
                                        ) : (
                                          ""
                                        )}
                                        &nbsp; - &nbsp;
                                        {propertyWatchLoading
                                          ? ""
                                          : priceFormat(
                                              propertyWatchData?.priceTo,
                                            )}{" "}
                                        {propertyWatchLoading ? "" : "Kr"}
                                      </p>
                                    </div>
                                  </div>
                                  <div className="col-lg-4 col-md-4">
                                    <div className="history-dsc ">
                                      <p className="word">
                                        <strong>
                                          {frontLabelsName
                                            ? frontLabelsName.filter(
                                                (e) =>
                                                  e.key == "lbl_street_name",
                                              ).length > 0
                                              ? frontLabelsName.filter(
                                                  (e) =>
                                                    e.key == "lbl_street_name",
                                                )[0]["value"] ||
                                                "lbl_street_name"
                                              : "lbl_street_name"
                                            : "lbl_street_name"}
                                          :{" "}
                                        </strong>
                                        {propertyWatchLoading ? (
                                          <Skeleton width={100} />
                                        ) : propertyWatchData?.location ? (
                                          propertyWatchData?.location
                                        ) : (
                                          ""
                                        )}
                                      </p>
                                    </div>
                                    <div className="history-dsc ">
                                      <p className="word">
                                        <strong>
                                          {frontLabelsName
                                            ? frontLabelsName.filter(
                                                (e) => e.key == "lbl_others",
                                              ).length > 0
                                              ? frontLabelsName.filter(
                                                  (e) => e.key == "lbl_others",
                                                )[0]["value"] || "lbl_others"
                                              : "lbl_others"
                                            : "lbl_others"}
                                          :{" "}
                                        </strong>{" "}
                                        {propertyWatchLoading ? (
                                          <Skeleton width={100} />
                                        ) : (
                                          propertyWatchData?.other?.length >
                                            0 &&
                                          includs(
                                            otherTypeField,
                                            propertyWatchData?.other,
                                          )
                                        )}
                                      </p>
                                    </div>
                                  </div>

                                  {/* <div className="col-lg-6 col-md-6">
                                    <div className="history-dsc ">
                                      <p className="d-flex align-items-center">
                                        <strong>
                                          {frontLabelsName
                                            ? frontLabelsName.filter(
                                              (e) => e.key == "lbl_size_range"
                                            ).length > 0
                                              ? frontLabelsName.filter(
                                                (e) =>
                                                  e.key == "lbl_size_range"
                                              )[0]["value"] ||
                                              "lbl_size_range"
                                              : "lbl_size_range"
                                            : "lbl_size_range"}
                                          :{" "}&nbsp;
                                        </strong>
                                        {propertyWatchLoading ? (
                                          <Skeleton width={100} />
                                        ) : propertyWatchData?.propertySizeStart !=
                                          null ? (
                                          priceFormat(propertyWatchData?.propertySizeStart)
                                        ) : (
                                          ""
                                        )}
                                        &nbsp;-&nbsp;
                                        {propertyWatchLoading
                                          ? ""
                                          : propertyWatchData?.propertySizeEnd
                                            ? priceFormat(propertyWatchData?.propertySizeEnd)
                                            : ""}{" "}

                                        {!propertyWatchLoading && <span>&nbsp;m<sup>2</sup></span>}
                                      </p>
                                    </div>
                                  </div> */}
                                  {/* <div className="col-lg-6 col-md-6">
                                    <div className="history-dsc ">
                                      <p className="d-flex align-items-center">
                                        <strong>
                                          {frontLabelsName
                                            ? frontLabelsName.filter(
                                              (e) =>
                                                e.key == "lbl_street_name"
                                            ).length > 0
                                              ? frontLabelsName.filter(
                                                (e) =>
                                                  e.key == "lbl_street_name"
                                              )[0]["value"] ||
                                              "lbl_street_name"
                                              : "lbl_street_name"
                                            : "lbl_street_name"}
                                          :{" "}
                                        </strong>
                                        {propertyWatchLoading ? (
                                          <Skeleton width={100} />
                                        ) : propertyWatchData?.location ? (
                                          propertyWatchData?.location
                                        ) : (
                                          ""
                                        )}
                                      </p>
                                    </div>
                                  </div> */}
                                  {/* <div className="col-lg-6 col-md-12 ">
                                    <div className="history-dsc ">
                                      <p className="word">
                                        <strong>
                                          {frontLabelsName
                                            ? frontLabelsName.filter(
                                              (e) =>
                                                e.key == "lbl_home_appliances"
                                            ).length > 0
                                              ? frontLabelsName.filter(
                                                (e) =>
                                                  e.key ==
                                                  "lbl_home_appliances"
                                              )[0]["value"] ||
                                              "lbl_home_appliances"
                                              : "lbl_home_appliances"
                                            : "lbl_home_appliances"}
                                          :{" "}
                                        </strong>{" "}
                                        {propertyWatchLoading ? (
                                          <Skeleton width={100} />
                                        ) : (
                                          propertyWatchData?.other?.length >
                                          0 &&
                                          includs(
                                            homeApplianceType,
                                            propertyWatchData?.other
                                          )
                                        )}
                                      </p>
                                    </div>
                                  </div>
                                  <div className="col-lg-6 col-md-12 ">
                                    <div className="history-dsc ">
                                      <p className="word">
                                        <strong>
                                          {frontLabelsName
                                            ? frontLabelsName.filter(
                                              (e) =>
                                                e.key == "lbl_restrictions"
                                            ).length > 0
                                              ? frontLabelsName.filter(
                                                (e) =>
                                                  e.key == "lbl_restrictions"
                                              )[0]["value"] ||
                                              "lbl_restrictions"
                                              : "lbl_restrictions"
                                            : "lbl_restrictions"}
                                          :{" "}
                                        </strong>{" "}
                                        {propertyWatchLoading ? (
                                          <Skeleton width={100} />
                                        ) : (
                                          propertyWatchData?.other?.length >
                                          0 &&
                                          includs(
                                            restrictionsType,
                                            propertyWatchData?.other
                                          )
                                        )}
                                      </p>
                                    </div>
                                  </div> */}
                                  {/* <div className="col-lg-6 col-md-12 ">
                                    <div className="history-dsc ">
                                      <p className="word">
                                        <strong>
                                          {frontLabelsName
                                            ? frontLabelsName.filter(
                                              (e) => e.key == "lbl_access"
                                            ).length > 0
                                              ? frontLabelsName.filter(
                                                (e) => e.key == "lbl_access"
                                              )[0]["value"] || "lbl_access"
                                              : "lbl_access"
                                            : "lbl_access"}
                                          :{" "}
                                        </strong>{" "}
                                        {propertyWatchLoading ? (
                                          <Skeleton width={100} />
                                        ) : (
                                          propertyWatchData?.other?.length >
                                          0 &&
                                          includs(
                                            accessType,
                                            propertyWatchData?.other
                                          )
                                        )}
                                      </p>
                                    </div>
                                  </div> */}
                                  {/* <div className="col-lg-6 col-md-6">
                                    <div className="history-dsc ">
                                      <p>
                                        <strong>
                                          {frontLabelsName
                                            ? frontLabelsName.filter(
                                              (e) =>
                                                e.key == "lbl_price_range"
                                            ).length > 0
                                              ? frontLabelsName.filter(
                                                (e) =>
                                                  e.key == "lbl_price_range"
                                              )[0]["value"] ||
                                              "lbl_price_range"
                                              : "lbl_price_range"
                                            : "lbl_price_range"}
                                          :{" "}
                                        </strong>
                                        {propertyWatchLoading ? (
                                          <Skeleton width={100} />
                                        ) : propertyWatchData?.priceFrom !=
                                          null ? (
                                          priceFormat(propertyWatchData?.priceFrom)
                                        ) : (
                                          ""
                                        )}
                                        &nbsp; - &nbsp;
                                        {propertyWatchLoading
                                          ? ""
                                          : priceFormat(propertyWatchData?.priceTo)}{" "}
                                        {propertyWatchLoading ? "" : "Kr"}
                                      </p>
                                    </div>
                                  </div> */}
                                  {/* <div className="col-lg-6 col-md-12 ">
                                    <div className="history-dsc ">
                                      <p className="word">
                                        <strong>
                                          {frontLabelsName
                                            ? frontLabelsName.filter(
                                              (e) => e.key == "lbl_others"
                                            ).length > 0
                                              ? frontLabelsName.filter(
                                                (e) => e.key == "lbl_others"
                                              )[0]["value"] || "lbl_others"
                                              : "lbl_others"
                                            : "lbl_others"}
                                          :{" "}
                                        </strong>{" "}
                                        {propertyWatchLoading ? (
                                          <Skeleton width={100} />
                                        ) : (
                                          propertyWatchData?.other?.length >
                                          0 &&
                                          includs(
                                            otherTypeField,
                                            propertyWatchData?.other
                                          )
                                        )}
                                      </p>
                                    </div>
                                  </div> */}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {watchTabId === 2 && (
                      <div
                        className="tabactive tab-pane active wishlist-property"
                        id="2b"
                      >
                        {loading ? (
                          <DashboardTableLoader />
                        ) : (
                          criteria.length > 0 &&
                          criteria.map((obj, index) => (
                            <div className="row noneDecor">
                              <div className="col-lg-12 col-sm-12">
                                <div className="favourite-white-box">
                                  <div className="my-favourite-box">
                                    <div className="row dash-row-style">
                                      <div
                                        className="col-lg-2 col-sm-2 col-xs-12 align-self-center mt-2"
                                        key={index}
                                      >
                                        <img
                                          src={
                                            obj?.cover_photo
                                              ? obj?.cover_photo
                                              : obj?.photo_gallery[0]
                                          }
                                          alt="user-notification"
                                          className="watchlistimage"
                                        />
                                      </div>

                                      <div className="col-lg-9 col-sm-9 col-xs-11 mt-lg-0 mt-md-2  favourate-message-col">
                                        <div className="criterialocation">
                                          <p className="ptag">
                                            {obj?.location}
                                          </p>
                                        </div>

                                        <div className="favourite-subtext truncate-overflow">
                                          <div className="criteriadescription">
                                            <p>{obj?.description}</p>
                                          </div>
                                          {/* <a
                                      className="anchorTag"
                                      onClick={() =>
                                        handleExpand(false, null)
                                      }
                                    >
                                      ...read less
                                    </a> */}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))
                        )}

                        {/* <div className="wa-box-main">
                        <div className="row align-items-center"> */}

                        {/* <div className="col-lg-12 col-sm-12">
                            <div className="favourite-white-box">
                              <div className="my-favourite-box">
                                <div className="row dash-row-style">
                                  <div
                                    className="col-lg-2 col-sm-2 col-xs-12 align-self-center"
                                    key={criteria._id}
                                  >
                                    <img
                                      src={
                                        criteria?.cover_photo
                                      }
                                      alt="user-notification"
                                      className="favorate-img pe-2"
                                    />
                                  </div> */}
                        {/* <div className="col-lg-9 col-sm-9 col-xs-11 mt-lg-0 mt-md-2  favourate-message-col">
                                    <div className="align-item-center">
                                      <p className="favourite-text">
                                        {criteria?.location}
                                      </p>
                                    </div>
                                    {expand === true &&
                                      expandId === criteria?._id ? (
                                      <div className="favourite-subtext truncate-overflow">
                                        {criteria?.description}
                                        <a
                                          className="anchorTag"
                                          onClick={() =>
                                            handleExpand(false, null)
                                          }
                                        >
                                          ...read less
                                        </a>
                                      </div>
                                    ) : (
                                      <div className="favourite-subtext truncate-overflow">
                                        {trimString(
                                          criteria?.description,
                                          240
                                        )}
                                        {criteria?.propertyData?.description
                                          .length > 240 && (
                                            <a
                                              className="anchorTag"
                                              onClick={() =>
                                                handleExpand(
                                                  true,
                                                  criteria?._id
                                                )
                                              }
                                            >
                                              read more
                                            </a>
                                          )}
                                      </div>
                                    )}
                                  </div> */}
                        {/* </div>
                              </div>
                            </div>
                          </div> */}
                        {/* <div className="col-lg-9 col-md-9 min-width-dash1">
                            <div className="d-flex align-items-center justify-content-center mobile-hhn-set">
                              <div className="col-lg-12 col-md-12 d-flex align-items-center flex-wrap">
                                <div className="col-lg-4 col-md-4">
                                  <div className="pr-watch">
                                    <p>
                                      <label className="radio">
                                        <input name="propertyWatch" type="radio" value={propertyWatch} onChange={(e) => HandleWatchList(e, 3)} checked={propertyWatch} />
                                        <span>Property Watch is off</span>
                                      </label>
                                    </p>
                                  </div>
                                </div>
                                <div className="col-lg-4 col-md-4">
                                  <div className="pr-watch">
                                    <p>
                                      <label className="radio">
                                        <input name="propertyWatch" type="radio" value={propertyWatch} onChange={(e) => HandleWatchList(e, 3)} checked={propertyWatch} />
                                        <span>Property Watch is on</span>
                                      </label>
                                    </p>
                                  </div>
                                </div>
                                <div className="col-lg-4 col-md-4">
                                  <div className="pr-watch">
                                    <Link to="/property-watch">
                                      <button>Change search criteria</button>
                                    </Link>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div> */}
                        {/* <div className="col-lg-12 col-md-12">
                            <div className="bsc-main-title">
                              <p>
                                The Property Monitor monitors properties that match
                                your wishes for a property to rent
                              </p>
                            </div>
                            <div className="border-bottom">
                              <div className="row">
                                <div className="col-lg-3 col-md-3">
                                  <div className="history-dsc">
                                    <p className="word">
                                      <strong>Type: </strong>
                                      <br />
                                      {propertyWatchData?.propertyType?.length >
                                        0 &&
                                        getTypeName(
                                          propertyWatchData?.propertyType
                                        )}
                                    </p>
                                  </div>
                                </div>
                                <div className="col-lg-3 col-md-3">
                                  <div className="history-dsc">
                                    <p className="word">
                                      <strong>Room: </strong>
                                      <p>
                                        &nbsp;{" "}
                                        {propertyWatchData?.bhk?.length > 0 &&
                                          propertyWatchData?.bhk?.toString()}{" "}
                                        {propertyWatchData?.bhk?.length > 0 &&
                                          "rooms."}
                                      </p>
                                    </p>
                                  </div>
                                </div>
                                <div className="col-lg-3 col-md-3">
                                  <div className="history-dsc">
                                    <p className="word">
                                      <strong>Zip Code: </strong>

                                      {propertyWatchData?.area?.length > 0 &&
                                        propertyWatchData?.area?.toString()}
                                    </p>
                                  </div>
                                </div>
                                <div className="col-lg-3 col-md-3">
                                  <div className="history-dsc custom-add-right-border">
                                    <p>
                                      <strong>Message sent with: </strong>
                                    </p>
                                    <div className="new3">
                                      <form className="d-flex flex-column">
                                        <div className="form-group new-color-add">
                                          <input type="checkbox" id="Email" name="email" value={email} onChange={(e) => HandleWatchList(e, 1)} checked={email} />
                                          <label for="Email">Email</label>
                                        </div>
                                        <div className="form-group new-color-add">
                                          <input type="checkbox" id="sms" name="sms" value={sms} onChange={(e) => HandleWatchList(e, 2)} checked={sms} />
                                          <label for="sms">SMS</label>
                                        </div>
                                      </form>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-lg-3 col-md-3">
                                  <div className="history-dsc">
                                    <p>
                                      <strong>Availability Type: </strong>

                                      {propertyWatchData?.availabilityType ===
                                        "short term" && "Short term"}
                                      {propertyWatchData?.availabilityType ===
                                        "long term" && "Long term"}
                                    </p>
                                  </div>
                                </div>
                                <div className="col-lg-3 col-md-3">
                                  <div className="history-dsc ">
                                    <p>
                                      <strong>Available From: </strong>
                                      <br />
                                      {propertyWatchData?.availabilityFrom &&
                                        moment(
                                          propertyWatchData?.availabilityFrom
                                        ).format("ll")}
                                    </p>
                                  </div>
                                </div>

                                <div className="col-lg-3 col-md-3">
                                  <div className="history-dsc custom-add-left-border mb-nn-line">
                                    {propertyWatchData?.availabilityType ==
                                      "short term" && (
                                        <p>
                                          <strong>Available To: </strong> <br />
                                          {propertyWatchData?.availabilityTo &&
                                            moment(
                                              propertyWatchData?.availabilityTo
                                            ).format("ll")}
                                        </p>
                                      )}
                                  </div>
                                </div>

                                <div className="col-lg-3 col-md-3">
                                  <div className="history-dsc custom-add-right-border mobile-hn-sd"></div>
                                </div>
                                <div className="col-lg-4 col-md-4">
                                  <div className="history-dsc ">
                                    <p>
                                      <strong>Price Range: </strong>
                                      {propertyWatchData?.priceFrom}-
                                      {propertyWatchData?.priceTo}
                                    </p>
                                  </div>
                                </div>
                                <div className="col-lg-6 col-md-12 ">
                                  <div className="history-dsc ">
                                    <p className="word">
                                      <strong>Others: </strong>{" "}
                                      {propertyWatchData?.other?.length > 0 &&
                                        propertyWatchData?.other?.toString()}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div> */}
                        {/* </div> */}
                        {/* </div> */}
                      </div>
                    )}

                    {limit >= 11 && (
                      <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        mt={2}
                        mb={2}
                      >
                        <ThemeProvider theme={theme}>
                          {criteriaDocs.length > 0 && (
                            <Pagination
                              count={criteriaPage}
                              color="primary"
                              page={page}
                              onChange={handlePageChange}
                              shape="rounded"
                              sx={{ textAlign: "center" }}
                            />
                          )}
                        </ThemeProvider>
                      </Box>
                    )}
                  </div>
                </div>
              </div>

              {runningsubscriptions?.message ==
                "Your subscription is expired." && (
                <div class="backdrop-second" style={{ zIndex: 0 }}>
                  <div className="popdiv ">
                    <Button
                      className="button-get-access"
                      onClick={() => handleSubscribe(allSubscription?._id)}
                    >
                      {frontLabelsName
                        ? frontLabelsName.filter(
                            (e) => e.key == "lbl_get_access",
                          ).length > 0
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_get_access",
                            )[0]["value"] || "lbl_get_access"
                          : "lbl_get_access"
                        : "lbl_get_access"}
                    </Button>
                  </div>
                </div>
              )}
            </div>
            <div className={`col-lg-6 col-md-12 ${isMobile ? "mt-0" : ""}`}>
              <div className="fr-chat-main mb-hh-df">
                <div className="frs-chat-desc">
                  <h3 className="d-flex align-items-center">
                    {frontLabelsName
                      ? frontLabelsName.filter(
                          (e) => e.key == "lbl_tenant_list",
                        ).length > 0
                        ? frontLabelsName.filter(
                            (e) => e.key == "lbl_tenant_list",
                          )[0]["value"] || "lbl_tenant_list"
                        : "lbl_tenant_list"
                      : "lbl_tenant_list"}
                    <Link to="/what-is-renter-info">
                      <span className="ps-2">
                        <img
                          src="assets/report.svg"
                          alt="report"
                          width="20"
                          height="20"
                          className="mx-2"
                        />
                      </span>
                      {frontLabelsName
                        ? frontLabelsName.filter(
                            (e) => e.key == "lbl_what_is_tenant_list",
                          ).length > 0
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_what_is_tenant_list",
                            )[0]["value"] || "lbl_what_is_tenant_list"
                          : "lbl_what_is_tenant_list"
                        : "lbl_what_is_tenant_list"}
                      ?
                    </Link>
                  </h3>
                  <div className="d-flex align-items-center pe-2">
                    {isLoading ? (
                      <Skeleton width={100} />
                    ) : (
                      <>
                        <span
                          className="switch-text me-1"
                          style={{ color: "#fff" }}
                        >
                          {frontLabelsName
                            ? frontLabelsName.filter((e) => e.key == "lbl_on")
                                .length > 0
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_on",
                                )[0]["value"] || "lbl_on"
                              : "lbl_on"
                            : "lbl_on"}
                        </span>

                        <Switch
                          isOn={checked}
                          handleToggle={() => handleChange()}
                          disabled={false}
                          id={"react-switch-new-1"}
                        />
                        <span
                          className="switch-text ms-1"
                          style={{ color: "#fff" }}
                        >
                          {frontLabelsName
                            ? frontLabelsName.filter((e) => e.key == "lbl_off")
                                .length > 0
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_off",
                                )[0]["value"] || "lbl_off"
                              : "lbl_off"
                            : "lbl_off"}
                        </span>
                      </>
                    )}
                  </div>
                </div>
              </div>
              <div className="white-box-ref wish-main-kk ">
                <div className="info-renter-info pb-1">
                  <div className="desc-infooo">
                    <h2 />
                    <button
                      onClick={() =>
                        // history.push("/update-renter-info")
                        history.push("/tenant-profile")
                      }
                    >
                      {frontLabelsName
                        ? frontLabelsName.filter((e) => e.key == "lbl_edit")
                            .length > 0
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_edit",
                            )[0]["value"] || "lbl_edit"
                          : "lbl_edit"
                        : "lbl_edit"}
                    </button>
                  </div>
                </div>

                <div className="row ">
                  <div className="col-lg-6 col-md-12">
                    <div className="set-wh-hg" style={{ paddingRight: 15 }}>
                      <div>
                        <p className="family-information-htag renter_info_heading">
                          {frontLabelsName
                            ? frontLabelsName.filter(
                                (e) => e.key == "lbl_family_information",
                              ).length > 0
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_family_information",
                                )[0]["value"] || "lbl_family_information"
                              : "lbl_family_information"
                            : "lbl_family_information"}
                          :
                        </p>
                      </div>
                      <div className="all-info-ddd">
                        <strong>
                          {frontLabelsName
                            ? frontLabelsName.filter(
                                (e) => e.key == "lbl_size_of_family",
                              ).length > 0
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_size_of_family",
                                )[0]["value"] || "lbl_size_of_family"
                              : "lbl_size_of_family"
                            : "lbl_size_of_family"}
                        </strong>
                        {authLoading ? (
                          <Skeleton width={100} />
                        ) : (
                          <p>
                            {tenantList?.familySize
                              ? tenantList?.familySize
                              : "N/A"}
                          </p>
                        )}
                      </div>

                      <div className="all-info-ddd">
                        <strong>
                          {frontLabelsName
                            ? frontLabelsName.filter(
                                (e) => e.key == "lbl_no_children",
                              ).length > 0
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_no_children",
                                )[0]["value"] || "lbl_no_children"
                              : "lbl_no_children"
                            : "lbl_no_children"}
                        </strong>
                        {authLoading ? (
                          <Skeleton width={100} />
                        ) : (
                          <p>{tenantList?.child ? tenantList?.child : "N/A"}</p>
                        )}
                      </div>

                      <div className="all-info-ddd">
                        <strong>
                          {frontLabelsName
                            ? frontLabelsName.filter(
                                (e) => e.key == "lbl_no_of_person_work",
                              ).length > 0
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_no_of_person_work",
                                )[0]["value"] || "lbl_no_of_person_work"
                              : "lbl_no_of_person_work"
                            : "lbl_no_of_person_work"}
                        </strong>
                        {authLoading ? (
                          <Skeleton width={100} />
                        ) : (
                          <p>
                            {tenantList?.workPerson
                              ? tenantList?.workPerson
                              : "N/A"}
                          </p>
                        )}
                      </div>
                      <div className="all-info-ddd">
                        <strong>
                          {frontLabelsName
                            ? frontLabelsName.filter(
                                (e) => e.key == "lbl_rent_budget",
                              ).length > 0
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_rent_budget",
                                )[0]["value"] || "lbl_rent_budget"
                              : "lbl_rent_budget"
                            : "lbl_rent_budget"}
                        </strong>
                        {authLoading ? (
                          <Skeleton width={100} />
                        ) : (
                          <p>
                            {tenantList?.budget ? tenantList?.budget : "N/A"}
                          </p>
                        )}
                      </div>
                      <div className="all-info-ddd">
                        <strong className="minwidth-fit-content">
                          {frontLabelsName
                            ? frontLabelsName.filter(
                                (e) => e.key == "lbl_deposit_type",
                              ).length > 0
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_deposit_type",
                                )[0]["value"] || "lbl_deposit_type"
                              : "lbl_deposit_type"
                            : "lbl_deposit_type"}
                        </strong>
                        {authLoading ? (
                          <Skeleton width={100} />
                        ) : (
                          <p>
                            {tenantList?.depositType?.filter(
                              (item) => item !== "",
                            ).length > 0
                              ? getDepositTypeName(tenantList?.depositType)
                              : "N/A"}
                          </p>
                        )}
                      </div>
                      <div className="all-info-ddd">
                        <strong>
                          {frontLabelsName
                            ? frontLabelsName.filter(
                                (e) => e.key == "lbl_man_type_work",
                              ).length > 0
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_man_type_work",
                                )[0]["value"] || "lbl_man_type_work"
                              : "lbl_man_type_work"
                            : "lbl_man_type_work"}
                        </strong>
                        {authLoading ? (
                          <Skeleton width={100} />
                        ) : (
                          <p>
                            {tenantList?.typeOfWork
                              ? tenantList?.typeOfWork
                              : "N/A"}
                          </p>
                        )}
                      </div>
                      <div className="all-info-ddd">
                        <strong>
                          {frontLabelsName
                            ? frontLabelsName.filter(
                                (e) => e.key == "lbl_women_type_work",
                              ).length > 0
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_women_type_work",
                                )[0]["value"] || "lbl_women_type_work"
                              : "lbl_women_type_work"
                            : "lbl_women_type_work"}
                        </strong>
                        {authLoading ? (
                          <Skeleton width={100} />
                        ) : (
                          <p>
                            {tenantList?.spouseOfWork
                              ? tenantList?.spouseOfWork
                              : "N/A"}
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-12 ">
                    <div>
                      <p className="family-information-htag renter_info_heading">
                        {frontLabelsName
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_housing_need",
                            ).length > 0
                            ? frontLabelsName.filter(
                                (e) => e.key == "lbl_housing_need",
                              )[0]["value"] || "lbl_housing_need"
                            : "lbl_housing_need"
                          : "lbl_housing_need"}
                        :
                      </p>
                    </div>
                    <div className="all-info-ddd">
                      <strong className="min-width-class">
                        {frontLabelsName
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_type_of_property",
                            ).length > 0
                            ? frontLabelsName.filter(
                                (e) => e.key == "lbl_type_of_property",
                              )[0]["value"] || "lbl_type_of_property"
                            : "lbl_type_of_property"
                          : "lbl_type_of_property"}
                      </strong>
                      {authLoading ? (
                        <Skeleton width={100} />
                      ) : (
                        <p className="break-all">
                          {tenantList?.apartmentType?.length > 0
                            ? getTypeName(tenantList?.apartmentType)
                            : "N/A"}
                        </p>
                      )}
                    </div>
                    <div className="all-info-ddd">
                      <strong className="min-width-class">
                        {frontLabelsName
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_zip_code",
                            ).length > 0
                            ? frontLabelsName.filter(
                                (e) => e.key == "lbl_zip_code",
                              )[0]["value"] || "lbl_zip_code"
                            : "lbl_zip_code"
                          : "lbl_zip_code"}
                      </strong>
                      {authLoading ? (
                        <Skeleton width={100} />
                      ) : (
                        <p className="break-all">
                          {tenantList?.area_required?.length > 0 &&
                          tenantList?.area_required?.[0] != 0
                            ? tenantList?.area_required?.toString()
                            : "N/A"}
                        </p>
                      )}
                    </div>
                    <div className="all-info-ddd">
                      <strong>
                        {frontLabelsName
                          ? frontLabelsName.filter((e) => e.key == "lbl_bhk")
                              .length > 0
                            ? frontLabelsName.filter(
                                (e) => e.key == "lbl_bhk",
                              )[0]["value"] || "lbl_bhk"
                            : "lbl_bhk"
                          : "lbl_bhk"}
                      </strong>
                      {authLoading ? (
                        <Skeleton width={100} />
                      ) : (
                        <p>
                          {tenantList?.rooms?.length > 0
                            ? tenantList?.rooms?.toString()
                            : "N/A"}
                        </p>
                      )}
                    </div>
                    {/* <div className="all-info-ddd">
                      <strong>
                        {frontLabelsName
                          ? frontLabelsName.filter(
                            (e) => e.key == "lbl_pets"
                          ).length > 0
                            ? frontLabelsName.filter(
                              (e) => e.key == "lbl_pets"
                            )[0]["value"] || "lbl_pets"
                            : "lbl_pets"
                          : "lbl_pets"}
                      </strong>
                      {authLoading ? (
                        <Skeleton width={100} />
                      ) : (
                        <p>
                          {tenantList?.pets
                            ? tenantList?.pets == 1 ? frontLabelsName
                              ? frontLabelsName.filter(
                                (e) => e.key == "lbl_yes"
                              ).length > 0
                                ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_yes"
                                )[0]["value"] || "lbl_yes"
                                : "lbl_yes"
                              : "lbl_yes" : tenantList?.pets == 2 ?
                              frontLabelsName
                                ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_no"
                                ).length > 0
                                  ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_no"
                                  )[0]["value"] || "lbl_no"
                                  : "lbl_no"
                                : "lbl_no" :
                              frontLabelsName
                                ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_agreement"
                                ).length > 0
                                  ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_agreement"
                                  )[0]["value"] || "lbl_agreement"
                                  : "lbl_agreement"
                                : "lbl_agreement"
                            : "N/A"}

                        </p>
                      )}
                    </div> */}
                    <div className="all-info-ddd">
                      <strong>
                        {frontLabelsName
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_days_delivery",
                            ).length > 0
                            ? frontLabelsName.filter(
                                (e) => e.key == "lbl_days_delivery",
                              )[0]["value"] || "lbl_days_delivery"
                            : "lbl_days_delivery"
                          : "lbl_days_delivery"}
                      </strong>
                      {authLoading ? (
                        <Skeleton width={100} />
                      ) : (
                        <p>
                          {tenantList?.dayDelivery
                            ? moment(tenantList?.dayDelivery).format(
                                "DD/MM/YYYY",
                              )
                            : frontLabelsName
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_right_away",
                                ).length > 0
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_right_away",
                                  )[0]["value"] || "lbl_right_away"
                                : "lbl_right_away"
                              : "lbl_right_away"}
                        </p>
                      )}
                    </div>
                    <div className="all-info-ddd">
                      <strong>
                        {frontLabelsName
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_length_rental",
                            ).length > 0
                            ? frontLabelsName.filter(
                                (e) => e.key == "lbl_length_rental",
                              )[0]["value"] || "lbl_length_rental"
                            : "lbl_length_rental"
                          : "lbl_length_rental"}
                      </strong>
                      {authLoading ? (
                        <Skeleton width={100} />
                      ) : (
                        <p>
                          {tenantList?.totalMonths
                            ? `${tenantList?.totalMonths} ${
                                frontLabelsName
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_months",
                                    ).length > 0
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_months",
                                      )[0]["value"] || "lbl_months"
                                    : "lbl_months"
                                  : "lbl_months"
                              } ${tenantList?.totalYears} ${
                                frontLabelsName
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_years",
                                    ).length > 0
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_years",
                                      )[0]["value"] || "lbl_years"
                                    : "lbl_years"
                                  : "lbl_years"
                              }`
                            : "N/A"}
                        </p>
                      )}
                    </div>
                    {/* <div className="all-info-ddd">
                      <strong>
                        {frontLabelsName
                          ? frontLabelsName.filter(
                            (e) => e.key == "lbl_minimum_size"
                          ).length > 0
                            ? frontLabelsName.filter(
                              (e) => e.key == "lbl_minimum_size"
                            )[0]["value"] || "lbl_minimum_size"
                            : "lbl_minimum_size"
                          : "lbl_minimum_size"} (m<sup>2</sup>)
                      </strong>
                      {authLoading ? (
                        <Skeleton width={100} />
                      ) : (
                        <p>
                          {tenantList?.minimum_size_required
                            ? tenantList?.minimum_size_required
                            : "N/A"}

                        </p>
                      )}
                    </div> */}
                    <div className="all-info-ddd">
                      <strong>
                        {frontLabelsName
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_queries",
                            ).length > 0
                            ? frontLabelsName.filter(
                                (e) => e.key == "lbl_queries",
                              )[0]["value"] || "lbl_queries"
                            : "lbl_queries"
                          : "lbl_queries"}
                      </strong>
                      {authLoading ? (
                        <Skeleton width={100} />
                      ) : (
                        <p>
                          {tenantList?.queries_comment
                            ? tenantList?.queries_comment
                            : "N/A"}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="payment_modal">
          <PaymentModal
            showModal={showPaymentModal}
            closeModal={savePaymentModal}
            amount={allSubscription?.amount}
            id={allSubscription?._id}
            setDashboardSubDetails={setDashboardSubDetails}
            setRunningSub={setRunningSub}
          />
        </div>
      </div>

      <Suspense fallback={<Loading />}>
        <Footer />
      </Suspense>
    </React.Fragment>
  );
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  label: state.language,
  language: state.language,
  // favrite: state.favrite,
});

export default connect(mapStateToProps, {
  loadUser,
  changePassword,
  getAllChat,
  getfavriteList,
  getPropertyList,
  likeProperty,
  gethiddenList,
  hiddenProperty,
  getapplyPropertyList,
  unlikeProperty,
  unHideProperties,
  runningSubscription,
  getPropertyWatch,
  dashboardSubscription,
  ChangeTenantStatus,
  watchList,
  watchListDetail,
  dropdownPropertyField,
  getAllSubscription,
  getTenantList,
})(Dashboard);
